/* eslint-disable no-unused-vars */
import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { minBy, maxBy, meanBy, sortBy, sum, groupBy, uniq } from "lodash";
import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, ReferenceLine,
  RadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Cell,
  ComposedChart
} from "recharts";


const LOGO_WHITE = "data:image/png;base64,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";
const LOGO_BLACK = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAW0AAAB4CAYAAAA5baO+AAArLUlEQVR42u2deZwkVZXvv5mV1c3eQovNJosou2wNtCAKwgiKSruA4gIKzlPcRmcccR0dxqeOT30zKs/Pc0aWlhHQZhFFYcSNHRSFphHFFgS6oUEWwcamuyqX+eOc84lTl8ysiFzqRlXd8/nEpyozI27cuHHv75x71goZVYAWsD3wf4AXAaP6fYVEg6ImUNf/axHHtwFUgbuAw4H1+n0r0riMaJ9OAz4MjOv4EGls5gInAFe4viVKVBoy4JgPLNeFm46ZfTT07+ccA4k9/+YCd5ZkfP4IbOL6lyhRKajmpJw68G5gL5W65qThmfG0FjjL7QBikUmyLwV20bk4ElHKrgHnAk/q//U0VRKVDbRtS7yPLt5aki5mNDUUFH8GrFA1SUzQbuocPCWQvqeaWjouY8C3SsDMEiV6GlWDBfKgfpf0d7ODztJ3X408B5vATsBRDjhjMbOKMrM7S8DMEiXqKGnbxDwbOBVRjaTJOjwmGZOaCor3Ika2VmQmbcD4RmBjtwuIQSa8/GfQt0SJSg0oJwD3kwx1wzL+NSP3YUz/fjZg3LFA0gyQdzDRQDrVh72Xe0gGyETTQNI2CawKXABcCexNMkYOEpzGFCgXubGOQaazPTfYZcUSFBrAS4DdI0vZtgM5j2SATDTNaCQNwVBoc+DRQKqb6qOuf39YEnWN3f872q/xiFJ2U5nZXiVSZSVK1FXSNjJjTJq0gxvjOvAeYAv9P5ZKwrb7SxwwxZK07d7PBl4eWWAwN7+fAbeTdNmJEs1qtUgFiSz9HUln205g+HBkKdvvQN7QRZhJlCjRLKARBcajIgO2B8UvlASYKtqH5ZHHxu57L+K9EpuZJUqUKDJoQ6azrRPXc2U9sIdTT8Qel5eWkJklm06iRLOUDBS3B/5CXFc/YxZXlgCwPTCeXwJm1lTg3rMkY5MoUaJIZOqHDzHRPzomaJ9QAtWIZ2ZrKIc3zU8SYCeabsCSaPDUQAyQJ0UGBPM/foDM1a8MEZCvRwyi9RLMwzODvvX6XEkXnmjY1EpDMNzt/5HE19mahP/FoG+xyLxplkdWjZh0vxLY1PUtUaIkac9iensJuGMN0dmeW4K+jChYHooEsTSJ75t9oappei10YMVDdkf88BsJ/BMNSbquItG6iYaw/QfYFniCLNou6WwzgP4vyuFNM4akI+5nbOyZLivBM6Vj5h/LppukPR0kGJMm3whsRjl0tuc4YIoZAdkAtgFeGZmJWI6Tq4FlfY6LSUEbl0T9lGhmkhUGaU4X0Lat63RQwo8rczkxMjBZXuoHgUsdWMXcgZgBcl5JmNlZA2BmNie/i0Sb1kleKIkGJ6Q2EbXbq/TzmukA2r4owzOmAXOpA4chWRJjZvOrIwa/byN+4jGL01bIdMhvjbxrMma2GvjeAJiZgfaXE8YkGhLtDCzW/x8pO2h76eyDwHaU37WqiXgjxARsz0DOCcAlJuM9BNiXchggv4PYHAbFzPy8TIbIRIMSdlqBsFotM2jbYjpepcXpRjFB0nS219C/znaQdLJjbNWIC6FB5k0zSGadaHYDrP/bGgAW2LqdIFTUSjwATd3ef4rMKl+bhi8xJi1x6oDYBsitdIsXuwbkCHAV8Ctmbj3USg9jnLfsXLUHhtuu7ZEhrJHQ02LY87rKRJ//TgDd6dyeqMwg2EIKB2zj+pq2nfkkviqis73EgVVM1UgTSXu6eUmY7zeDvs00MiFnWPNrEGPWmIJ5VxkESAbMsOrGwI/DRogHkc3tccSldE2bc2v04VhRdsl1DaJ33IwsN3WiyRdVDbgIeJy4BkhbnFUknL8V8R2aHv3BkjCzYTLIPYA3u7GfDOAriLH6y0gmyG5t7w+8rkDbVeAh4AwHXKPAcWSFnCsDmGPrkMCT1YgXz2OBVN/vu7Y2rJ3nAy8EDgZ2BRYgtqxRfZ5x4Cntxz3AL4BrgRvcGM84ocG2d59026u6G7h0tD/GdZwWBuMY8x2+UPsU8/2t03n0tRKMy7DIhLD3UDxo4z53faXLuzyvh7bNJmU1Z/dluAEoDwLfB/6WLEVBrzYUX8VrI23zGnpPAHcHkkRu0xzzsOrGyyTz75ZdL1fVifQlsoxw6Zj8uEknQ03/xjoMBM4v0dgcpH0bjTguwwbtTzhJb3ySY53+vawLuBmIb4LkahlXabFbu2N6/zHgRXr9XP37dgWhtcrIx/s86u4Io49/r1J9L4zaj8UJwG+YGFFr928EKhN/NNwz+hxEv1Fhplu/2oJ22XXaprj/IPAVYKekIpl0zEDqHJZp6/9l4D+J51FTUfB4AklUNRNVI/79b+sAPM8arwH3d9mym8H2cMTttpmjXXMkWKFChB/zA7TN0SExMW/wex6wFPg48NkCqhI7b3Pgq6puMl31CPkNspU249JQFdaPkOjgnxVRlUwXb4wqUg7q3oTLuSbJgcAukcHDgOBu4MYSjMszkRzeB0dm/CPArbpzHBZt3UXN0Ynuy3HOqxzwTAZYds7FyjBrTg++qE+VRZ41YMzAcsF8Rp/xv3IAt/2+M2Ib2seB9egAsMyY4EaqOloIrJqJOu5q5K1+2Y+5Okanl0gVcbzTZcZU0cwNtrYxjz8pA2EIzMPau4n8yavsnBM7CHLW5sYqNOVNNWy2hIVBuzuq2mQqi19YXx4EtqS7U4Mxkp2BPzLcAibr9e/ZHdQk006nnajYYq0AG+h2tOl0aFN9mF5xhfZnGOBURKqtAEe4xRfLEGoL9EtD2uXaGG+gu5u8oGhg8JIOwGGfjy7ACKzNX7l3YM+7mDg55m38/77L+Jub4HzEYOivG1ZOd9Pt79Bm99EWtFNim5lBI/pC/wZ4rtM5ViMc5kL2LcTIVSNudGiLLK95JdKYmEF9jMxHvDUk0N5C9bB5x6aqQLx6kn69qkC/7ZylZAFNRoc49UmMNbI40K+Hgk8LSSS2uwo+c4YsbLWADYGjhqwySlRC1RGqPyxDodynEN/VmJPQ7rsN4q9ehrzmPx3imFibezmprEm+6j2PqHQZ7ors/w2d9N7I2eZ6YLdgxwPw80hz1D9rO/WUMZZ3T4GEHc6Npgo54U4nSdozGLCbqis8ivhh4hXgx8CdxM/fDeKqNY9yVJQ5Z4igbc823437ZM9rEvGDwJ+7jOEixHMrrwESxPj8O9cXi3DeIxIzt7HwUdaVYA1tC3yazPNlKlWbO+fdgSTQnjlS9psRY1G9BH1awsSghFgMpEb8vOYWibmazIjUGNLixwFSHmZpoL3aAXI79cdre2jzQjfuNvZ7IobAPAwlHEOzDfQTlm7qoM2CMTM1xccpXjLO66b7EVC2UFXMpFHDCbSnN1nGurkOnGJJ2QZO9wA/IH8ComGQ6S8PdVvLmKANkgr2L65vw6KtA/DMA7D3tsEDm1tzgJflxAvb5a0hSxXgAbpXfbb3HPM5RfoVdOz/BvAcXUN5fNAJnq3q+tbqYQ2jAtcGeS5IhX2nN5k/6ZGIDjlmylO793mITrtWAqn/5AIANux3tGSK+rJjAAZ5aFUHYGuoauS5BVQjlkVxVRs1zUEF+2ZS53LgYW3vGdqfTfqY7+PBczaBd2ibeROa+Xvfpv3bScG/l37lnhcJtLNJVJ2m/W4Bb2szkWKA03oy74hmxDFpqMS5OPLuwzwnrgVuYbg6/lYgaRehlV0kwMVuTPPOrQscILbcbnCfHhjKGJKgaoW7difEw+PFBea8MYA6Ypg2qiN5QN7o1Cd5Afs3wKlIEqiGgv7/Q5KjNXLOO+vXOn3WRDnBZjrTtkh2szJ4R1yecxs9TDJB5O+0T+PE86SpB0x1mEKSAeG1FA+sOTpYC9bWKFlQUl6vkccQvXUoDO2t7yLvHLX7/U5VNFWnhgB4OcW8UOy+DyP6Y3s+gFcUmCu2zh5V5mHPaW0topgfuvdpr3RQ4+zLNMk9MpXS0Nb6Aoatbxw0sxlHog43LsDZh0ln9SBJDeN9Vh1QlqEW5cWub8PccY2QP9rSzq+ThbC3AtXIAYi/ch5p1ubfDxUYR9x3TW2rVlACBam8NBa0VyVLA1BU1bIS8ZTxevHXkr9wghm4z0MiJudo/0wNNK/HHdLjTtJvJvVIe7LBOR14H/kDEspIMd38QgNkTNWIAYQZIGPWorTCyhczdYWV57l5nBfMHleQ9QBi1x5TQDVirmtLO9z7wOAeecHs+qBP1p/tCrZnjGc5WW6cuqptDqd4tZ8bAuA3xrl3cL+8z3l3gEsJtNss7gbwD0i+bijuhlQmitlvm5wXIOG4sQ2QLeAUiuthhzXHzpqi928FYOcVGKeKAvafO0iTi3Oqu0xouA/x0W854DH3uYMKqs5s13tjB3DepyBoG/066MfuSCKxvCBra+1PgXTecuqRXmh5Uf3fbCJbzBsA73W6rhES9QpOY2SFcmMbIBcg6S7LUIvyOjID5FS4Pz5TJcc8FYIMZB52wNpyzGYvxK86j3HOdhWXA391bZjUuIOCY14Bw/r/EKLTJmACXnLPK7BUA9D2bogmaBSRjDd3uwube6O6w7MoxzzCi+nI78jLhGazn/amKpVUSP7q/YBTBbhaJ13MCEgD6OORqMB6CXZOZ5LfI2EQO63temCc9wdYYG29pgCzsWu/3aFfeyOh8Hl3s9b/25Ac6D6nTUvX7Z4FMMzewYOIjtzfY+8ex3xRG3XSHog7Yg3RdddyHGZk/X1e0J6t6pGKbglXIpbkcVKl915VEQDfcAsoFmibdPu2yAKJSasPAZcG0uGw58M2BVQGds59QRsmIb8y5zia3WCF7iw8IFYClUFRPe91wbyqul3AAvLXHLU+3o7YFzwz2r5Hif044J8RlaBdO4ZkcRwr0F5NVS2r8jLc2Qja3mp+OmIoGp2mzxFbl13TyfbDKQKnblK2BYIsLIFqxAorP8bUFlbergegXxEAUhMpWvv8nLuEdsUO6gEAvbAgMNp5vwxA3L5/AZnPdS3nWvGqEQ/aRb097NodgPcjxRWsD78F/nHYL3m2StomTVyiHPNDSCRZlfIbI83yvVnk/tpiPR9xvypTBGQj4ty2RX1OhB3PVgXA0c65N1AhNBED5GhOUDSPnaVtALZJ8SRRxnD/6lQZobHvgB6ZwA0d+l9092rv+GPAFWR5w/vxVsq9dmazy5/p1y7SYwsmuhWVkaoqzZyJ+JbG8s22hTWOlG/KuyUflmqggRjhXkM5DJA3ADe7vk01aOc53wD6oaD/FcTVL886MMZ9C1JCzT+vAdvuwLN6VGXc78DfG/v2K7BObT6s1X6GKoj1Pcxfu+9GiL/2wWS+30MXXGZ7cE3LccjHpkmfFyDFDvJKLsNieCOIAfI2ps47opOkVwdejxggxxhu4vo8dA4TfYGn4n1A8TJmTyL5pe2aFmLgy6tiMtC+yO1u6kEfDim4+2kFqhF7v9a/XcifCwXHLO4m0xu33Jx9tI9519D+nIsUifCFFIYquc12argXW+ZjVP+epKqRmN4RLQdOseeRLd6Tgu1uLAHgEbK0pFPByLzUt2VO0Lb396gTVnxAzWiOvtvzjpGlnG22uceiHp/nFx2waj8naBVhaLe4nZCX+lf0sVO05z8G+MJU7XwTaE+cZGU+6joh3hL53dliXclw80PnXTRNBYYDiRsBaWPgDZBToTLyxQ/mF2S6q1U9UHVCwLE555epUm5E3D3D6EBL67pPwflqKsBftGEEvTABo2uC8bIxuKHP9TSq/f0HJKgrr3E0gfYMJwOiFyNW/ZjZ/GyxLtXtdRnytZxEXHdD3HZ7yRTf10DoWSptFwmsucfNr5aqHQ4siA1L2+xw7P7PI0uqlDd7nqky7grUGzbvDi7QXss9268DJmB/ryfzBW/2OP6mFvqaqoPqwxQeEmhPr53AyfSfAH4QDMR7R5TBAHkc8Q2QVZUOb2LqDJCetuphbtwdAO4xSERlPcdcrCFeQ+1UI75MWa3AWNhcus0Bnw+q2Yas7mQRz5HVPD14xebLnxAPEPpYV/a8cxBvqm0ZYgqFBNrlJ5PgtiGriB0zCZJtNZdTjgjI1ypwl6EG5JIIKpqKA+2iwHN/oNp5dU5AbLp5sKrLPFhY8Fmagcoi9ObaC8loWTSy8hZlMJ0qy3yV/uMejDltjxTpnUNmj0qgPQtBG+ANxC9Qa5PwrBLMHxuHkwtKXsPYAY0gRr2LAhCcakk77zhUA9AeVzXGQQV3LOfTPg1EmCQq77sxG8X1gVTca7kyu/7GDvPVpOHrkAyV/QZC1RAbwWHKCAZlmLS82/XIu+xEBYByBNHJNcgSyU/1YRPmfiSbXEygtIVwgI5Hnayw6lQflkv5G5F2QWb0OoNiifxbZEEqIMnT8lxv1z5KexdDA8btkQAZf02edh/g6YV3rc0rKVb4wDzDjunybqpOin+KYoUaOj3HmP7/zj7nhPVtf9f+lbUhgUyiwYFTHcn3u19k6dYm3oVIDuZaRKnf7nkq8WMNLAXCmZHGwqTJ7XKuP1MDrEX0uUavzHm9SY+XI+6NoXRq1z8fMYzmNZqbWmk5WX4QU4M0kQRvRSMrrVjCbcFYtbvv7cCngM8rcI/2MTfNMPl/VcpfRm+qRO+aeb62e1NtwAspZpDFTCTTIS/WBbY+Mkh5ibIeeVw2RTwdHiReLvQmortchhggY6hGDAgWFLzuT2SBNTsg+UHyAKypyC7sMOZhEd+iSaKud8Dsk0TthlSYyqt7tvN+y8TIym6M6As6DsfSn+ue953/BlKUwwcIFQXte4E3hVurQQC2bUfmkD+nb6LJJ10T+Cc9YrrWVdy2cdNI77cVCAiHkb9M1DDHZR1xdI227jYgK+ibx4g4okC2Vr87CilKO5mE6Ysd/ISJxQ4ImNahBXfeBuy/aPOuQVz9iiSJ8iH2eaJT7X4nKwMuEnXZSW01riqo04BP07vO3NsNWrUBTpx5SKrCV5DfXzRR923oBkhSmjNL0qdTdQsZU+K3yt7vJEt9Ottpc4rbGVa5/19TQDVSU9XImg6qEcOCvXpQZTxJ5yRRvQbV/KLAjmUECYw6EUnRUO0Tx0yFeJqqN+7qQ00ysB2cbZXmOs6bjsEdaxGDjhkjY4XQV1UCu70k4/IQEwtYlCHNQAwyQHw+mdFtMiOaGRq/qNdurwCc51oz9h6h14YGNvv8AvIbIL1h8aaAeVQc+OWtCh8aBIswD699yGuYnewwo+TZHcZsysk6cIJ2bB3xrPgz6TCPhCUleNHGLI7UPo1HfMfr9e8XB6zem65k8+KwAiBpIPQhfa+nkM8jw8Dy9yqkdQO8DxQEPDvvK0E7BrS7KrbkBUrr6x90t1pkB+Lv/02Keat0Yh5NxJNmp4IMpCun7kfS9py+WiLJZzofI27SlEHF5IvlxpRuTS+5xG1pExULrLH5dJ++19cVUB+A5KDvpB5rOf0zPczdTkmi9ldGUTSycrmCfdFUC4Zl70Y8T/rx37bo2I3IXw1oqKBt9ACpMO6gyIwfy4Gr3CSKtf1uIGG5r2Rq6h1OtpDKEI1ZFgqjIVsF1vzvEePjITmxoFOxgxCcfJKoIiW31pOlYw3f60EFns+fd0OPzMP02E8Cb0ZcEPtNudrS3WrfwkZ1AABTQfIPPExW7aIxDY8m8RMf+Rd6LkNOPFNgfhyPBDyUIVT87AELHDOBtikIRuuRlKQvRwyYk6X5tXW+DPHGaJdbxa5/LvCcAgze5nuYJMoLKy8oCL4jgeTey7o2o+vtiAG+6tQuvaoYF1IsDH/oC/tQJEXjdDb81SPf3/Rfa1S6jQ1Olsd7GcWMQMMYlxbi8TCvR+lpJpKB07cpppe2EmMX5LzOdM4fc5JxO2kZ4K0U02fbvc8LnsnvIp6geGTln5HMh/3OFXuur2i76/uYv+uBnftd14Mw5BjXuFY5yUKVyprTZGF55/0vEddV0bj7DxA/2tgJmZq6fd478vusK/NYqgt4Kovlll2VBpmPdl61wX0qYeetgNSt2EFIiwakyrB1+XyHJ0UiK3+LBBBVnNRf6XGMRxC3vUMU34r6b1sf5iCFKu7qZy0Nyvpug/KUgvd0pIVkyeBjFoWFzC87NtNrAW93kzfmuIwjhtlEE4Gg1oNE+QcFoPk5AMjXvbyjiyBhqrMDA4k5j3DQIkvqFAbVLHLzr0hk5Y2u/X4TLVURg+Y7kORSc3oQ7uz8Dft98YNchCaJVafhxN8EeFfByTYMqamK+KNeRdy82SblLCB+OlgDjevorE+dzbRJAZWRAdoDiD67SDTpxW5uNNvMlybwbLL8IEVCzR8E7gykePtbVJ9t9MtAEHo5Eu04xuTeJLb2RoF/QfTac5CkbecgOu5+8pMkGgDTegODcaTv57B7nzYEhtrruLyfiQECMe0MJ5VgXMpEBkY76w43b3BMC/gM8Lsc19hva8gSUlU7SMsg0dBFbB/2bq8I2jaA3hjRvxcJ1LE4h921DSvy/K0e598Obt5VEFXhGL3bdxb1KwTNdgu8cfNTSqCGGNHFcX7Qt1jSrS+WG7vq+4PEr0dZxl0iSAj7BuSzOZiaaVuyQI/KJPMAJi92YG0cWHDumrR7XQfQ3lWZRV5VhI3BH/RAn7eC2KzqCrj1SQ4D5WuVaVQcSP8G8byp9vCc42SFlHv2VJvNoG2DvidZRFnMfBoVlThWUqza9KDJto6HIkENZSiWuxTxlS1DPcqy0dYFgXIMyWQ3p8BYdip2EL6nokmiwsrrrQCXDqZY5lC7fplTX7RUbbOrzp9RXefdjqqeuyxYE2YAv6NH4H2cLB1uAu0+nv1EikVbDbMvZ1Eej5u39Tu5BsRAmmT1KBM9HfC2L3jdBmR+1JUcu7/HkARRnZIW9ZMkagQJYFkezDX7e1APO1aAm4N+9OoffU2HMb+n4NowhnoX4v3UV6BOdRZP+DpixHkDcYvCmgHyt8BPI6sATKrZCqkXGDMC0ruS3kLK1d6JioK2TzyWZ/f332TFDlpdMGQ3xIuliCoDJEz8ATLjn6kiRnSnVwSnrI/XB98XjaisId4inSI0x3tkJr9y/exbwpttZIN2NLAjcX2QfQTkGOWIgHwdoiutE7f2YkXHpUWyv3QCggU9XFukjuS3JwH5MN91UVXGL4M1ae3tBDyvQH9tvjyE6J0hy5+9sEA7PkLzvg5g/8we39mvBrlIZxuVzQC5FolOa8fVp5LMAHly5Plh4/IwmatZkrLbg16Rgr5Fd3+ryFIuNybpxyE9Mo48SaKKgO0yMvtHAwki2qfAfG46gK0HO4xmsLupFJjLY2SpZ6PmHpmOZAbIXZGIsJiqEZuQlwN/JL4BEsQvdj/KYYC8CNGpJgNkZ3DZcgigbeN/GaJz7jT+JlmPIpGLeTHF1ly3JFEHFFRp2HlXOhUHiN/4lhQPhrk6GFdT38whcwMssgO4A/FF7zv+YraCNogBcg7lMECeQ9xk+n6CnUz8DHqmvz47YXNXKXVDRI01jPFvAd/J2Y+dKZYkygD2LlVD+O8aTt1SBKNMsr4yaG/3gkBpDOrWgJnYsz4bUanm7Zs9z1Vkuvq+qNbhJczkyd5Ectu+OTLjsi3oCjfRYhsgt0RKT8XefVRVAruZFAHZjTYn069WBjgvR1QqvG6S7bwx94OcADRSYO7f6q5pOGaxAAliyftc1t7tKtF6kN61gMRuUvETSO4ff5317VDEAydvugvDl+8X3DlMCtq2LZ/pW1B7vpcpt4yZZ8Qm2rfIksrHqnBui+91SD6KmONiC/UssnwndRKF49NCvDU2GdK8/B6ih80z/kW9M4xuIvP/trDx9Uju9s0oXsT3EneNgfZuPTC1tXp41YiN+fE9MMA/kOVk6nsHW2OiK9V8ZnYxA5scfxuZQZkk+xTiHTGQlzkA6fZk4mY59AbIiyLvPqaDemQbJ1UOasdoAty3cwCxvZteXPOaiB+0pXBAAXtHpEB4s2B7deBC12dbT9v2ANrPADZVidsYwDjwYqRyfd7kafYMFw9SMLMOHQ18XPU/Mz23Q1O5eMwISOPAVyI6vdgpWBsqLR1QAtVITSf5o6QUrJOB9rMGteV242+RgLfSXTVlc3ZbJKo4L7O38+5HQsTn6D23AF6qgL1dAVWLnfcTxNXPr6UNKKbzNwa4IfAR4B/JypX9je7+agXXls9OOZA1XkOyX11KylgVY9GdGSyAmHQK8QNYbByWpCmSi7YbMGibMPEdx0Drk8zhfciqGo3knPstBekb3XufrxKu70cROiNoH2UIGxaUtG0OvgepOr+KiTr2vDsAG48ftWEmfdOvyTK5zZZq5zGr01jimRWIQTSm10jFqcX+FHl8bFxupByeNGUmk/a+ymCzU1rF+91zqDusD/80wD6MU6x6lJ17swJkmHBqHpJsrFVwXjd5eha/BsUy+1nfDndS98Be/s5OVZAWytSoRqpIEp61xDW0mS7wOMRzJGaOYJOOlrj5mAyQ3cdqm4JSZB7J8AYkpcJkkqH9dmgffWgGAkStx3E4vYOkX1cm1IswU3FAX7ROgPXlCuDnw9jBrtAGY9dHnA2HcfC1ZCG6sWtAguRqaBIvn7gVVn6MzIUtha1P/t6uYXC1Ta2N9waSdLf7bwas7kGSHWT++R92mS8VJG/NVNY3bWjfxsgChAZuI3oPTy8sm47hHDbRvl8CYLKJdCBZ/uBYqiorsnDmsCb5DATsOSpwDQKQ7D08iQSPTDY3/dyJoVJrKpP5C7BLB0nY+nghU1u029b4vw17Ln9YpZwkDU/N8eoet4PDAO1vRJKU2h0v1HFJoD05aD/LrdnmgIDmBzmFCZu372XqKz6Z3r2FuO52Akbr4wensI/GGG5H/Od7LSacS3fTUv3Y9sT3YpgN9OsS6Wv3RizssTIdWujzOOJmluZfdzJd8x6Ia97IAN6bBaSciAR7jUwyP80V83zgBAYUnp1zrtQRu8sZwPvobPvwRU5u1c/D3Nna+vmr6vmXMWSvsCTZJEo0PcjW6mEDVo08Qr7kUxUnyf5mCvXFXsI+l6y6TCXHWF2i160foh7b7IKvHjam2haiMSxRPlFbakyyKEYc9x625FmW995KUnYh9ciWbtz6lRCriKfDw0we0GQ78+eQeZ4NW4K1TIJzgH8H/t71o5VjvD6KBMdsPOBdgQF2DbHLnIjUMk2eT4kSJXqaoPUBBqOrNSn52KD9ye5/IsMx8DWd1Oqf7X7gLQ6IiwTLACx2kva6PncHVvHdnn0FEuKetBazjHwx068D/6HSAST3t0RPB83PKag9pX97Ocb07yrEfW8y1Yi//78P4P52WBX0dkD6APB5smIPvejwDUgPR3zQveFw3N27kwdVIzjXrn8KCXCanwB7di/Gd7pJ8ZGc0k+i2UMGDD8YoHT79QKgY+q73zIc/fA6JCveecBJTCztNTKAcdsUySlyex99XAl8mazww5QCdgKD8tE6Mn3Y2jQciQIyvf8ZiP603sdOzNKh/ph8FcLtnBHgM0hCpkF4HdV1rj+EBOvcx8RIxhEn8fZKZrdbA3xRQfcgpFLTIuC5KjFvrGNiEZFrkeRlK5Ec79cjKWUfH2DfEk1zSfttjqN/IDHXRLN4RzGM1Brd4gA2Usl+ayR74VZI/pJqh/5VYwJFokSJph+oGXA0ckjJNboX6MW1Uelwrge8drrlTtdU3e9mRAz73HLttoLPdHhG8732/W7ncdWur7U2/V7bYXdbRTxXrB+hZN1Jzx72ZTJ9fC5vsQTaiRJNT2oU3JLXO0iddAH88PeWayePS9tkQTrtgk/yuBv6a5s52s3TZqVLn81bxDOVvH32fRmICiWBdqJE048MCI4C9kVSETxGe720gdF7kFwd32wDJgciQSH7KibcieTsuDo4dw/gNLKAnCeQaNoN9LynEJ/oJ8j8vTfXto9UtcOfkYIFS5GAnrBowUf1PJNK1yKpVy/W/lcckO4CvAtYqPe6FvG6WsnEEmYfQXKqWJvrkCjJSxDfdK+rr+vfVyG1BnZSwL4RMY76oiV23anAfm7nM6ZjeBGin7fzP6pjOKZjVScryDJXz7+EVPxj2lDSaScqAtogFb5biJdFu3liqgXzSLpCP1v63a0UDFuIse06xMj2V/3ubAUT0y2/BKm2dKkCb0tB6bva9hIFXuvfWxXAW0j05FUKZi0kz/URQb93JfN7vhwpIPBLd/2zHWi/BjFW3gOco0yghbgv7unO21G/vwfJCPgjfUb7blc918bkMLJEXHdrn5e5XcY7grEdVebzBHCZtn+NAvOfdczsvK/pOF2i19g7uVSvWxy0nSiBdqIZQAZGGyu41BW0wsVuka7bqTQ5DnzCtbGjgtJfkPwhc92184Av6Rz81w5AsrO2eXyH/n1Krz8P8czw9CIF7UcDID5Wn+fA4Pwjta2v6OfNtd9XMNEYuL+ed5n77giVWo8I2lyk557jvjtev7uOrFix0W4qbfvCBmj/m0hiKoLvHwN+RftgoMsQt8lECbQTzRIpew/d5o+r9DonAE0D2QvIUt++Sb+bS+a29rygbQ+CV6o0u8D9PlfbtuLYC3V+znF9eI3+9vkAzH37ljvlM+6cTygAmipjjmM+jwP/recdTpYtEySjXs1J98e5+7xPz93dtWljs1oBuqK/r1dpvBKMiZ2/QCXqH7vfD9c+H+vaN6n9cgXuUbeOR3QMH1EJ2/cpBdEl0E40A2nESaUt3XI3nXTqQebVqur4Dz3Xqqa/pQ2Ie6AyP+U36XlHu3v7iMgxsrqOVadmuAe4w10zEoC3fV5JVicSRI/+KKInrznpfyftx+f0sxWgXtJhDfn/z1LmtpkDSAPghu4oUAB9iqxYcq1D299F8o5vqp/fr33Zy/W54p7v520Y4g56zSfS+k6gnWj2zJOPOUl3PZIT30CzqsD3iALD5xRgN9Frr1Ypcy7tE4YZqL5UGcLx7t4GPD9FIhfDfpkU/M4uc9fUBbcEKoK7VDolYCDfQwySO5DloTcd9s/J0j3Y+d61bhkSEONpjl6/HklHPV8B/MwufTa9vjFJ232cp9J0SPZ+jmnDvI7QNl7RQfWUawIkSpRoepB5h+yHGLoM+F7m1BFNVTs0FbCvVkB8UsF8fwXH9WQRfe1AdTOnmsC1XUOMfTe1AR3TFV9F5jcdtm3P8AxEt41KuFvpbyYdVxXYNgNeD9xL5uFxkgLyB1WNsxwpMnwpme/2ZkiQTBPxzKjp8++tDOs4xJB6FFmmw0qXcW8hwTdrVE0Cku1wLuLBU1fmeKi+n9NU3WK+9Ia3ZihdEbzTQvqxRIkSTQ9qOtC+Qz9fBhwCbKHAsS+SvvRtChZ7A7fpdZsjRszVdM+W10IMhjhVh9HWCrI3OyA22ko/P0r71Kmm294a0V1bG89FPE/WqER9okrrSxF982UB+K0D/jdiUH0HYjz9roK4jdGz9fu7yBI+rdLrdkHK/lV0TFpMrN7Vbjyqqpr5vd5/U1XdPKwS+9GIDn0VsA/wBdr7ou+vqphVvYB2oqQeSTR9yMBxnoLQGYFKwtQEtzo1w/P0tw/r52eqhP3NDnNrxEnZ5lNtAp7PltdEfJntGmvns/rbjrSvFmM65U8GjOGt+nk//fxmbectwXWdNAWbquS/zqkuXq1tHtxhPK3NxXreYu1vrcN5x+h5f+ck5pYCtY11nSwB12iH97cMqV4FqYZBAu1EM5oMNPfV+XGyA/G1SPDG6/U3c6VbrODn0/zegqQ8nevApRaoOZZoOy9oA8xWDHy3NoB+bABk1rbXh++vErN3zfs3/e5Z2tY8lWDvJjOMgujlT0f07RV9BtPVfyjo16f18/bapu+LD69/DhMNmyPuvBHH7O5VKduMkMfr2L7EMbsfO6bltRnW/430XZ2V1nYC7USzZ468SQFukfvtUsRr4y9I6lGjDwYgggP2JQoinhY4wD4tAB67/9d1e7+xA6SKA9Fl+vthbZ7hWMSj5U6nSgExKK4I7vPFYAdhBtaWk1Q9XY1kCtzIjcmqNsDpqRowqZPbnHMg8DsF2wPc9/+s72Eb9525O34yeJaqk8YbTlpPazuBdqJZMEf+v86P+e63U8kCQ6pua36pqkPmBODxr3r+Q0jNxa8hXhpWkOB/Bed70FtB5vVRaQOAewJ/JPPu+DoSxGI5uK/UnYBdP6og/z2njqioxGxt+GcyN7urlCl9QkG8hRgXrS8PM9HlrpPKqYrYAyzC9FbEk+TrZAE1dzrAtn78FDHSeqawEWJcfYLMHdK7OVoAz0uD3VOiBNqJZiBVnQT6neC7XRD98/7BnDHwCSViFDguVgl9JRK9d7qqEzoB9iiiL/9YBzCsOnXCJxED6EoFvaVkLnAesOYjod+nuO/tfl9DcopsFVzzRmVQq1SFcgHi/ohTo/wMeG8OcLR7zVXmd732+Y9IePlbnSrJt3Mu4q8eqojepWB/qLvGfjtRn3WrLtJ/ogTaiRJ1ZACdaGSIbfcCVpWc1/bqEVeJ9Fw9A0WicpIP/U3umTOXmj3Mi9AH2r4LXdbanWv39Lmq/TZ+skosk6V0bbq2fB7sbrmxO7VZbfNMlpGv5Z4r/JynnwRt+udvBn1ulwa2Xfst8qW87dnNL4F2uWmcibl8EyWC9r7E3fyLOwFEow341HPeP8859QCkGj202czR905tt3oY10H0uTWA8UugPQ3VJGZo2hYxzKT8ujOXViuDjskEpmv7rWk6Jn1tvxOVB6zrwL8AH9dFbJw+vaeZLTUfjIRhV3tQlSSapVJdovKQJfGZm4YircNEidJkKbfEBeJmdDNZMp9EM/+dP5mGIlFe+h/9Afw1V4akGQAAAABJRU5ErkJggg==";

const THEMES = {
  dark: {
    bg: "#060608", bg2: "#0E0E12", sf: "#0E0E12", sf2: "#161d27",
    bd: "#18181B", bdl: "#27272A",
    ac: "#DC2626", ac2: "#DC2626", acd: "#991B1B",
    acg: "rgba(220,38,38,0.10)",
    warn: "#F59E0B", warng: "rgba(245,158,11,0.10)",
    err: "#DC2626", errg: "rgba(220,38,38,0.08)",
    ok: "#22C55E", okg: "rgba(34,197,94,0.10)",
    tx: "#FAFAFA", txm: "#A1A1AA", txd: "#52525B",
    ch: ["#DC2626","#FAFAFA","#A1A1AA","#F59E0B","#22C55E","#a78bfa","#f472b6","#fb923c","#818cf8","#e879f9","#2dd4bf","#fbbf24"],
    logo: LOGO_WHITE
  },
  light: {
    bg: "#FAFAFA", bg2: "#F4F4F5", sf: "#FFFFFF", sf2: "#F4F4F5",
    bd: "#E4E4E7", bdl: "#D4D4D8",
    ac: "#DC2626", ac2: "#DC2626", acd: "#991B1B",
    acg: "rgba(220,38,38,0.08)",
    warn: "#D97706", warng: "rgba(217,119,6,0.10)",
    err: "#DC2626", errg: "rgba(220,38,38,0.06)",
    ok: "#16A34A", okg: "rgba(22,163,74,0.10)",
    tx: "#09090B", txm: "#52525B", txd: "#71717A",
    ch: ["#DC2626","#09090B","#71717A","#D97706","#16A34A","#7C3AED","#DB2777","#EA580C","#4F46E5","#C026D3","#0D9488","#CA8A04"],
    logo: LOGO_BLACK
  }
};

// Default to dark, will be overridden by ThemeProvider at runtime
let T = THEMES.dark;


const SL = ["S1","S2","S3","S4","S5"];
const SNAMES = { S1:"GP-Strecke / Hatzenbach", S2:"Hocheichen / Flugplatz", S3:"Schwedenkreuz / Adenauer Forst", S4:"Metzgesfeld / Karussell / Galgenkopf", S5:"Dottinger Hohe / T13" };

/* ================================================================
   VDS LOGO
   ================================================================ */
function VDSLogo({ height = 44 }) {
  return (
    <img src={T.logo} alt="VDS Motorsport" style={{ height: height, width: "auto", display: "block" }} />
  );
}


/* ================================================================
   UTILITIES
   ================================================================ */
function pt(val) {
  if (!val || val === "N" || val === "" || val === "NaN") return null;
  const s = String(val).trim();
  if (s.includes(":")) {
    const p = s.split(":");
    if (p.length === 3) return +p[0]*3600 + +p[1]*60 + parseFloat(p[2].replace(",","."));
    if (p.length === 2) return +p[0]*60 + parseFloat(p[1].replace(",","."));
  }
  const n = parseFloat(s.replace(",","."));
  return isNaN(n) ? null : n;
}
function ft(sec) {
  if (sec == null || isNaN(sec)) return "\u2013";
  const m = Math.floor(sec/60);
  return m + ":" + (sec%60).toFixed(3).padStart(6,"0");
}
function fgs(sec) {
  if (sec == null || isNaN(sec)) return "\u2013";
  return (sec >= 0 ? "+" : "") + sec.toFixed(3) + "s";
}
function parseCSV(text) {
  const lines = text.split("\n").filter(l => l.trim());
  const fl = lines[0];
  const sep = fl.split(";").length > fl.split(",").length ? ";" : ",";
  const headers = fl.split(sep).map(h => h.trim().replace(/^"|"$/g,"").replace(/\r/g,""));
  return lines.slice(1).map(line => {
    const vals = []; let cur = "", inQ = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === "\r") continue;
      if (ch === '"') inQ = !inQ;
      else if (ch === sep && !inQ) { vals.push(cur.trim()); cur = ""; }
      else cur += ch;
    }
    vals.push(cur.trim());
    const obj = {};
    headers.forEach((h,idx) => { obj[h] = vals[idx] || ""; });
    return obj;
  });
}
function processData(rawRows) {
  return rawRows.map(r => {
    const lapSec = pt(r.RUNDENZEIT_IN_SEKUNDEN) || pt(r.RUNDENZEIT);
    const sectors = SL.map((_,i) => pt(r["SEKTOR"+(i+1)+"_ZEIT"]));
    const stnr = parseInt(r.STNR);
    const klasse = (r.KLASSE||"").trim().replace(/^0+/,"").trim();
    const drivers = [];
    for (let d = 1; d <= 8; d++) {
      const nm = (r["FAHRER"+d+"_NAME"]||"").trim();
      const vn = (r["FAHRER"+d+"_VORNAME"]||"").trim();
      if (nm) drivers.push(vn+" "+nm);
    }
    const fn = parseInt(r.FAHRER_NR);
    let ad = drivers[0] || "Unknown";
    if (fn >= 1 && fn <= drivers.length) ad = drivers[fn-1];
    const ip = (r.INPIT||"").trim().toUpperCase();
    let lt = "Flying";
    if (ip === "J") lt = "PitIn";
    else if (ip === "A") lt = "Outlap";
    return {
      stnr, klasse, activeDriver: ad, drivers, lapType: lt,
      lapNr: parseInt(r.RUNDE_NR)||0, lapSec, sectors,
      stint: parseInt(r.STINT)||0, lapInStint: parseInt(r.LAPINSTINT)||0,
      team: (r.TEAM||r.BEWERBER||"").trim(),
      vehicle: (r.FAHRZEUG||"").trim(),
      topSpeed: parseFloat((r.TOPSPEED_KMH||"0").replace(",","."))||null,
      wet: false, // weather is now set manually per race
      cancelled: (r.CANCELLED||"").trim().toUpperCase() === "J"
    };
  }).filter(r => r.stnr && r.lapSec && !r.cancelled);
}
function flyOnly(data) { return data.filter(d => d.lapType === "Flying"); }
function bestSectors(laps) {
  return SL.map((_,i) => {
    const valid = laps.filter(d => d.sectors[i] != null);
    return valid.length ? minBy(valid, d => d.sectors[i]).sectors[i] : null;
  });
}

/* ================================================================
   UI COMPONENTS
   ================================================================ */
function KPI({label,value,sub,color,small}) {
  const c = color||T.ac;
  return (
    <div style={{background:T.sf,border:"1px solid "+T.bd,borderRadius:2,padding:small?"10px 12px 10px 16px":"14px 16px 14px 20px",position:"relative",overflow:"hidden",minWidth:small?100:130}}>
      <div style={{position:"absolute",left:0,top:0,bottom:0,width:3,background:T.ac}} />
      <div style={{fontSize:10,color:T.txm,textTransform:"uppercase",letterSpacing:"0.08em",fontWeight:600,marginBottom:4}}>{label}</div>
      <div style={{fontSize:small?18:22,fontWeight:700,color:T.tx,fontFamily:"'SF Mono',Monaco,'JetBrains Mono',monospace",letterSpacing:"-0.02em",lineHeight:1.1}}>{value}</div>
      {sub && <div style={{fontSize:10,color:c===T.ac?T.txd:c,marginTop:4,fontFamily:"'SF Mono',Monaco,monospace",fontWeight:600}}>{sub}</div>}
    </div>
  );
}
function Sel({label,value,onChange,options,w}) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:3}}>
      {label && <label style={{fontSize:9,color:T.txm,textTransform:"uppercase",letterSpacing:"0.08em",fontWeight:700}}>{label}</label>}
      <select value={value} onChange={e=>onChange(e.target.value)}
        style={{background:T.bg,color:T.tx,border:"1px solid "+T.bdl,borderRadius:2,padding:"5px 10px",fontSize:11,outline:"none",cursor:"pointer",minWidth:w||80,fontFamily:"inherit"}}>
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}
function Panel({title,sub,children,accent}) {
  return (
    <div style={{background:T.sf,border:"1px solid "+T.bd,borderRadius:2,padding:"14px 18px",position:"relative",overflow:"hidden"}}>
      {accent && <div style={{position:"absolute",top:0,left:0,bottom:0,width:3,background:T.ac}} />}
      {title && <h4 style={{margin:"0 0 8px",fontSize:11,fontWeight:700,color:T.tx,textTransform:"uppercase",letterSpacing:"0.06em"}}>{title}</h4>}
      {sub && <p style={{margin:"-4px 0 10px",fontSize:10,color:T.txd}}>{sub}</p>}
      {children}
    </div>
  );
}
function SimpleTable({headers,rows,compact}) {
  return (
    <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:compact?10:11}}>
        <thead><tr>{headers.map(h => <th key={h} style={{padding:compact?"4px 6px":"5px 8px",textAlign:"left",color:T.txm,fontWeight:700,fontSize:9,textTransform:"uppercase",letterSpacing:"0.05em",borderBottom:"1px solid "+T.bd,whiteSpace:"nowrap",position:"sticky",top:0,background:T.sf}}>{h}</th>)}</tr></thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}
function Badge({text,color}) {
  return <span style={{fontSize:9,padding:"2px 8px",borderRadius:2,fontWeight:700,background:(color||T.ac)+"18",color:color||T.ac,border:"1px solid "+(color||T.ac)+"30",whiteSpace:"nowrap",textTransform:"uppercase",letterSpacing:"0.06em"}}>{text}</span>;
}
function TabBtn({active,label,onClick}) {
  return <button onClick={onClick} style={{padding:"11px 16px",fontSize:11,fontWeight:600,borderRadius:0,border:"none",borderBottom:"2px solid "+(active?T.ac:"transparent"),cursor:"pointer",background:"transparent",color:active?T.tx:T.txm,whiteSpace:"nowrap",textTransform:"uppercase",letterSpacing:"0.05em",fontFamily:"inherit",marginBottom:-1}}>{label}</button>;
}

/* ================================================================
   RACE MANAGER (upload page with weather/temp)
   ================================================================ */
function RaceManager({ races, setRaces, activeRace, setActiveRace, onDone }) {
  const fileRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFiles = useCallback(files => {
    setLoading(true);
    const promises = Array.from(files).map(file => {
      return file.arrayBuffer().then(buf => {
        let text;
        try { text = new TextDecoder("iso-8859-1").decode(buf); }
        catch(e) { text = new TextDecoder("utf-8").decode(buf); }
        const raw = parseCSV(text);
        let name = file.name.replace(/\.csv$/i,"").replace(/_/g," ").replace(/N.*RBURGRING.*SEKTORZEITEN/i,"NLS Race").replace(/RENNENRENNEN/gi,"").trim();
        if (name.match(/^\d+$/)) name = "NLS Race " + name;
        const proc = processData(raw);
        if (!proc.length) return null;
        return { name: name || "Race " + (races.length + 1), data: proc, weather: "dry", temp: "" };
      });
    });
    Promise.all(promises).then(results => {
      const valid = results.filter(Boolean);
      if (valid.length) {
        setRaces(prev => {
          const next = [...prev, ...valid];
          setActiveRace(next.length - 1);
          return next;
        });
      }
      setLoading(false);
    });
  }, [races.length, setRaces, setActiveRace]);

  const updateRace = (idx, field, val) => {
    setRaces(prev => prev.map((r,i) => i===idx ? {...r, [field]: val} : r));
  };
  const removeRace = idx => {
    setRaces(prev => {
      const next = prev.filter((_,i) => i !== idx);
      if (activeRace >= next.length) setActiveRace(Math.max(0, next.length-1));
      return next;
    });
  };

  const weatherColors = { dry: T.ok, wet: T.ac, mixed: T.warn };
  const weatherLabels = { dry: "Dry", wet: "Wet", mixed: "Mixed" };

  return (
    <div style={{display:"flex",flexDirection:"column",gap:16,maxWidth:700}}>
      <h3 style={{margin:0,fontSize:16,fontWeight:700,color:T.tx}}>Race Manager</h3>
      <p style={{margin:0,fontSize:11,color:T.txd}}>Upload CSV files from the NLS timing system. Set the weather conditions and track temperature for each race manually.</p>

      {/* Upload zone */}
      <div onClick={() => fileRef.current.click()}
        onDragOver={e => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={e => { e.preventDefault(); setDragging(false); handleFiles(e.dataTransfer.files); }}
        style={{border:"2px dashed "+(dragging?T.ac:T.bd),borderRadius:12,padding:"28px 20px",display:"flex",flexDirection:"column",alignItems:"center",gap:10,cursor:"pointer",background:dragging?T.acg:"transparent",transition:"all 0.2s"}}>
        {loading ? (
          <div style={{color:T.ac,fontSize:13,fontWeight:600}}>Processing...</div>
        ) : (
          <>
            <div style={{fontSize:24}}>📂</div>
            <div style={{fontSize:12,color:T.tx,fontWeight:600}}>Drop CSV files here or click to upload</div>
            <div style={{fontSize:10,color:T.txd}}>Latin-1 encoding auto-detected. Multiple files supported.</div>
          </>
        )}
      </div>
      <input ref={fileRef} type="file" accept=".csv" multiple style={{display:"none"}}
        onChange={e => { handleFiles(e.target.files); e.target.value=""; }} />

      {/* Race list */}
      {races.length > 0 && (
        <div style={{display:"flex",flexDirection:"column",gap:8}}>
          <div style={{fontSize:11,color:T.txm,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.06em"}}>Uploaded Races ({races.length})</div>
          {races.map((r,i) => {
            const carCount = uniq(r.data.map(d => d.stnr)).length;
            const lapCount = r.data.length;
            const classCount = uniq(r.data.map(d => d.klasse)).length;
            return (
              <div key={i} style={{background:i===activeRace?T.acg:T.sf,border:"1px solid "+(i===activeRace?T.ac+"40":T.bd),borderRadius:10,padding:"12px 14px",cursor:"pointer"}} onClick={() => setActiveRace(i)}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <input value={r.name} onChange={e => updateRace(i,"name",e.target.value)} onClick={e => e.stopPropagation()}
                      style={{background:"transparent",border:"none",color:T.tx,fontSize:13,fontWeight:700,outline:"none",padding:0,width:180}} />
                    {i===activeRace && <Badge text="ACTIVE" color={T.ac} />}
                  </div>
                  <button onClick={e => { e.stopPropagation(); removeRace(i); }}
                    style={{background:"transparent",border:"1px solid "+T.err+"30",color:T.err,borderRadius:4,padding:"2px 8px",fontSize:9,cursor:"pointer",fontWeight:600}}>Remove</button>
                </div>
                <div style={{display:"flex",gap:12,fontSize:10,color:T.txd,marginBottom:8}}>
                  <span>{carCount} cars</span>
                  <span>{lapCount} laps</span>
                  <span>{classCount} classes</span>
                </div>
                <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}} onClick={e => e.stopPropagation()}>
                  <div style={{display:"flex",gap:4}}>
                    {["dry","wet","mixed"].map(w => (
                      <button key={w} onClick={() => updateRace(i,"weather",w)}
                        style={{padding:"3px 10px",fontSize:10,fontWeight:r.weather===w?700:400,borderRadius:5,border:"1px solid "+(r.weather===w?weatherColors[w]:T.bd),background:r.weather===w?weatherColors[w]+"18":"transparent",color:r.weather===w?weatherColors[w]:T.txm,cursor:"pointer"}}>
                        {w==="dry"?"☀️":""}
                        {w==="wet"?"🌧️":""}
                        {w==="mixed"?"⛅":""}
                        {" "+weatherLabels[w]}
                      </button>
                    ))}
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <span style={{fontSize:10,color:T.txd}}>🌡️</span>
                    <input value={r.temp||""} onChange={e => updateRace(i,"temp",e.target.value)} placeholder="e.g. 18°C"
                      style={{background:T.bg,border:"1px solid "+T.bd,borderRadius:4,padding:"3px 6px",fontSize:10,color:T.tx,outline:"none",width:70}} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {races.length > 0 && (
        <button onClick={onDone} style={{background:"linear-gradient(135deg,"+T.ac+","+T.acd+")",color:T.bg,border:"none",borderRadius:8,padding:"10px 24px",fontWeight:700,fontSize:13,cursor:"pointer",alignSelf:"flex-start"}}>
          Open Analytics →
        </button>
      )}
    </div>
  );
}

/* ================================================================
   DASHBOARD TAB
   ================================================================ */
function DashboardTab({data,car,hl,races,activeRace}) {
  const carData = useMemo(() => data.filter(d => d.stnr===car), [data,car]);
  const flying = useMemo(() => flyOnly(carData), [carData]);
  const kl = carData[0] ? carData[0].klasse : "";
  const classFly = useMemo(() => flyOnly(data.filter(d => d.klasse===kl)), [data,kl]);

  const bl = flying.length ? minBy(flying,"lapSec") : null;
  const t3 = flying.length >= 3 ? meanBy(sortBy(flying,"lapSec").slice(0,3),"lapSec") : (flying.length ? meanBy(flying,"lapSec") : null);
  const cb = classFly.length ? minBy(classFly,"lapSec") : null;
  const bs = bestSectors(flying);
  const tb = bs.every(s => s!=null) ? sum(bs) : null;
  const classPos = useMemo(() => {
    const g = groupBy(classFly,"stnr");
    const ranked = Object.entries(g).map(([s,l]) => ({stnr:+s,best:minBy(l,"lapSec").lapSec})).sort((a,b) => a.best-b.best);
    const pos = ranked.findIndex(r => r.stnr===car);
    return { pos: pos+1, total: ranked.length };
  }, [classFly,car]);

  const stints = useMemo(() => {
    const g = groupBy(carData,"stint");
    return sortBy(Object.entries(g).map(([s,laps]) => {
      const fy = flyOnly(laps);
      return { stint:+s, driver: laps[0]?laps[0].activeDriver:"?", laps:laps.length, fly:fy.length, best: fy.length?minBy(fy,"lapSec").lapSec:null, avg: fy.length?meanBy(fy,"lapSec"):null };
    }),"stint");
  }, [carData]);

  const chartData = carData.map(d => ({lap:d.lapNr,time:d.lapSec,driver:(d.activeDriver||"?").split(" ")[0],type:d.lapType,stint:d.stint}));
  const race = races[activeRace];
  const weatherIcon = race ? (race.weather==="dry"?"☀️":race.weather==="wet"?"🌧️":"⛅") : "";

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
        <span style={{fontSize:24,fontWeight:800,color:T.tx,fontFamily:"monospace"}}>#{car}</span>
        <span style={{fontSize:13,color:T.txm}}>{carData[0]?carData[0].vehicle:""}</span>
        {carData[0]&&carData[0].team && <span style={{fontSize:11,color:T.txd}}>| {carData[0].team}</span>}
        <Badge text={kl} color={car===hl?T.ac:T.txm} />
        {classPos.pos>0 && <Badge text={"P"+classPos.pos+"/"+classPos.total} color={classPos.pos<=3?T.ok:T.txm} />}
        {weatherIcon && <span style={{fontSize:12}}>{weatherIcon} {race.temp||""}</span>}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:8}}>
        <KPI label="Best Lap" value={ft(bl?bl.lapSec:null)} sub={"R"+(bl?bl.lapNr:"\u2013")+" | "+(bl?bl.activeDriver.split(" ")[0]:"")} />
        <KPI label="Top 3 Avg" value={ft(t3)} sub={flying.length+" flying laps"} color={T.ok} />
        <KPI label="Theo. Best" value={ft(tb)} sub={tb&&bl?"Potential: "+fgs(bl.lapSec-tb):"\u2013"} color={T.warn} />
        <KPI label="Gap to Class" value={cb&&bl?fgs(bl.lapSec-cb.lapSec):"\u2013"} sub={cb?"Best: "+ft(cb.lapSec)+" #"+cb.stnr:""} color={bl&&cb&&bl.lapSec<=cb.lapSec?T.ok:T.err} />
        <KPI label="Laps" value={String(carData.length)} sub={flying.length+" fly | "+carData.filter(d=>d.lapType==="PitIn").length+" pit"} color={T.txm} />
        <KPI label="Stints" value={String(stints.length)} sub={stints.map(s=>(s.driver||"?").split(" ")[0]).join(" → ")} color={T.txm} />
      </div>
      <Panel title="Lap Times" accent={T.ac}>
        <ResponsiveContainer width="100%" height={220}>
          <ComposedChart data={chartData}>
            <CartesianGrid stroke={T.bd} strokeDasharray="3 3" />
            <XAxis dataKey="lap" stroke={T.txd} fontSize={10} tickLine={false} />
            <YAxis stroke={T.txd} fontSize={10} domain={["auto","auto"]} tickFormatter={ft} tickLine={false} />
            <Tooltip content={({active,payload}) => {
              if (!active||!payload||!payload.length) return null;
              const d = payload[0].payload;
              return (<div style={{background:T.bg,border:"1px solid "+T.bd,borderRadius:8,padding:"8px 12px",fontSize:11,boxShadow:"0 8px 24px rgba(0,0,0,0.4)"}}>
                <div style={{color:T.tx,fontWeight:700}}>R{d.lap} | {d.driver}</div>
                <div style={{color:T.ac,fontFamily:"monospace",fontWeight:700}}>{ft(d.time)}</div>
                <div style={{color:T.txd,fontSize:10}}>{d.type} | Stint {d.stint}</div>
              </div>);
            }} />
            <Line type="monotone" dataKey="time" stroke={T.ac} strokeWidth={2} connectNulls
              dot={({cx,cy,payload:p}) => {
                const col = p.type==="Flying"?T.ac:p.type==="PitIn"?T.err:T.warn;
                return <circle key={p.lap} cx={cx} cy={cy} r={p.type==="Flying"?3.5:2.5} fill={col} stroke="none" />;
              }} />
            {bl && <ReferenceLine y={bl.lapSec} stroke={T.ok} strokeDasharray="5 5" strokeWidth={1} />}
          </ComposedChart>
        </ResponsiveContainer>
      </Panel>
      <Panel title="Stints" accent={T.ac2}>
        <SimpleTable headers={["St","Driver","Laps","Fly","Best","Avg","Gap"]}
          rows={stints.map(s => {
            const bst = stints.filter(x=>x.best!=null);
            const stBest = bst.length ? minBy(bst,"best").best : null;
            return (<tr key={s.stint} style={{borderBottom:"1px solid "+T.bd}}>
              <td style={{padding:"5px 8px",color:T.tx,fontWeight:700}}>{s.stint}</td>
              <td style={{padding:"5px 8px",color:T.ch[s.stint%T.ch.length],fontWeight:600,fontSize:10}}>{s.driver}</td>
              <td style={{padding:"5px 8px",color:T.txm}}>{s.laps}</td>
              <td style={{padding:"5px 8px",color:T.txm}}>{s.fly}</td>
              <td style={{padding:"5px 8px",color:T.tx,fontFamily:"monospace",fontWeight:600}}>{ft(s.best)}</td>
              <td style={{padding:"5px 8px",color:T.txm,fontFamily:"monospace"}}>{ft(s.avg)}</td>
              <td style={{padding:"5px 8px",color:s.best===stBest?T.ok:T.warn,fontFamily:"monospace",fontSize:10}}>{s.best&&stBest?fgs(s.best-stBest):"\u2013"}</td>
            </tr>);
          })} />
      </Panel>
    </div>
  );
}

/* ================================================================
   RACE BATTLE TAB
   ================================================================ */
function BattleTab({data,car,cls}) {
  const classData = useMemo(() => data.filter(d => d.klasse===cls), [data,cls]);
  const allCarsInClass = useMemo(() => {
    const g = groupBy(classData,"stnr");
    return sortBy(Object.entries(g).map(([s,laps]) => ({
      stnr:+s, vehicle:laps[0].vehicle, team:laps[0].team, laps:laps.length,
      best: flyOnly(laps).length ? minBy(flyOnly(laps),"lapSec").lapSec : 999
    })), "best");
  }, [classData]);

  const [rivals, setRivals] = useState([]);
  const [showPicker, setShowPicker] = useState(false);

  // Auto-pick closest rivals on mount
  useEffect(() => {
    const others = allCarsInClass.filter(c => c.stnr !== car);
    const carIdx = allCarsInClass.findIndex(c => c.stnr === car);
    // Pick car above, car below, and next one
    const picks = [];
    if (carIdx > 0) picks.push(others.find(c => c.stnr === allCarsInClass[carIdx-1]?.stnr));
    if (carIdx < allCarsInClass.length-1) picks.push(others.find(c => c.stnr === allCarsInClass[carIdx+1]?.stnr));
    if (picks.length < 2 && others.length > 0) picks.push(others.find(c => !picks.some(p => p?.stnr === c.stnr)));
    setRivals(picks.filter(Boolean).map(p => p.stnr).slice(0,3));
  }, [allCarsInClass, car]);

  const toggleRival = stnr => setRivals(p => p.includes(stnr) ? p.filter(x=>x!==stnr) : p.length<3 ? [...p,stnr] : p);

  const allSelected = [car, ...rivals];
  const colors = { [car]: T.ac };
  rivals.forEach((r,i) => { colors[r] = T.ch[i+1]; });

  // Build per-lap data for all selected cars
  const carLaps = useMemo(() => {
    const result = {};
    allSelected.forEach(stnr => {
      result[stnr] = sortBy(data.filter(d => d.stnr===stnr), "lapNr");
    });
    return result;
  }, [data, allSelected]);

  // Max laps across all selected
  const maxLap = useMemo(() => Math.max(...allSelected.map(s => carLaps[s]?.length || 0)), [carLaps, allSelected]);

  // 1. Overlay lap time chart
  const lapTimeData = useMemo(() => {
    const rows = [];
    for (let i = 1; i <= maxLap; i++) {
      const row = { lap: i };
      allSelected.forEach(stnr => {
        const lap = carLaps[stnr]?.find(d => d.lapNr === i);
        if (lap) {
          row["t_"+stnr] = lap.lapSec;
          row["type_"+stnr] = lap.lapType;
          row["driver_"+stnr] = lap.activeDriver;
        }
      });
      rows.push(row);
    }
    return rows;
  }, [maxLap, allSelected, carLaps]);

  // 2. Cumulative gap chart (running total of lap time difference)
  const gapData = useMemo(() => {
    if (rivals.length === 0) return [];
    const primary = carLaps[car] || [];
    const rows = [];
    const cumGaps = {};
    rivals.forEach(r => { cumGaps[r] = 0; });

    for (let i = 1; i <= maxLap; i++) {
      const pLap = primary.find(d => d.lapNr === i);
      const row = { lap: i };
      rivals.forEach(rStnr => {
        const rLap = (carLaps[rStnr]||[]).find(d => d.lapNr === i);
        if (pLap && rLap) {
          cumGaps[rStnr] += (pLap.lapSec - rLap.lapSec);
        }
        row["gap_"+rStnr] = +cumGaps[rStnr].toFixed(1);
      });
      rows.push(row);
    }
    return rows;
  }, [car, rivals, carLaps, maxLap]);

  // 3. Pit timeline
  const pitData = useMemo(() => {
    return allSelected.flatMap(stnr => {
      return (carLaps[stnr]||[]).filter(d => d.lapType === "PitIn").map(d => ({
        stnr, lap: d.lapNr, driver: d.activeDriver, time: d.lapSec
      }));
    });
  }, [allSelected, carLaps]);

  // 4. Stint comparison
  const stintData = useMemo(() => {
    return allSelected.map(stnr => {
      const laps = carLaps[stnr] || [];
      const g = groupBy(laps, "stint");
      const stints = sortBy(Object.entries(g).map(([s,sl]) => {
        const fy = flyOnly(sl);
        return {
          stint:+s, driver:sl[0]?.activeDriver||"?",
          startLap: sl[0]?.lapNr, endLap: sl[sl.length-1]?.lapNr,
          laps:sl.length, flyLaps: fy.length,
          best: fy.length ? minBy(fy,"lapSec").lapSec : null,
          avg: fy.length ? meanBy(fy,"lapSec") : null
        };
      }), "stint");
      return { stnr, stints, vehicle: laps[0]?.vehicle||"" };
    });
  }, [allSelected, carLaps]);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
        <h3 style={{margin:0,fontSize:15,fontWeight:700,color:T.tx}}>Head-to-Head | #{car}</h3>
        <Badge text={cls} color={T.txm} />
      </div>

      {/* Rival selector */}
      <Panel title="Select rivals (max 3)" sub="Click cars to add/remove from comparison" accent={T.ac}>
        <div style={{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
          <span style={{fontSize:10,color:T.ac,fontWeight:700,padding:"3px 10px",borderRadius:5,background:T.acg,border:"1px solid "+T.ac+"40"}}>#{car} (you)</span>
          {rivals.map((r,i) => {
            const info = allCarsInClass.find(c=>c.stnr===r);
            return <span key={r} style={{fontSize:10,color:T.ch[i+1],fontWeight:700,padding:"3px 10px",borderRadius:5,background:T.ch[i+1]+"15",border:"1px solid "+T.ch[i+1]+"40",cursor:"pointer"}} onClick={()=>toggleRival(r)}>#{r} {info?info.vehicle.split(" ").slice(0,2).join(" "):""} ✕</span>;
          })}
          <button onClick={()=>setShowPicker(!showPicker)} style={{fontSize:10,color:T.txm,background:"transparent",border:"1px solid "+T.bd,borderRadius:5,padding:"3px 10px",cursor:"pointer"}}>
            {showPicker ? "Close" : "+ Add rival"}
          </button>
        </div>
        {showPicker && (
          <div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:8,paddingTop:8,borderTop:"1px solid "+T.bd}}>
            {allCarsInClass.filter(c=>c.stnr!==car&&!rivals.includes(c.stnr)).map(c => (
              <button key={c.stnr} onClick={()=>{toggleRival(c.stnr);if(rivals.length>=2)setShowPicker(false);}}
                style={{padding:"3px 10px",fontSize:9,borderRadius:5,border:"1px solid "+T.bd,background:"transparent",color:T.txm,cursor:"pointer"}}>
                #{c.stnr} | {c.vehicle.split(" ").slice(0,3).join(" ")} | {ft(c.best)}
              </button>
            ))}
          </div>
        )}
      </Panel>

      {/* Lap time overlay */}
      <Panel title="Lap Times Overlay" sub="All cars on same timeline — pit-in laps show as spikes" accent={T.ac}>
        <ResponsiveContainer width="100%" height={240}>
          <ComposedChart data={lapTimeData}>
            <CartesianGrid stroke={T.bd} strokeDasharray="3 3" />
            <XAxis dataKey="lap" stroke={T.txd} fontSize={10} tickLine={false} label={{value:"Lap",position:"insideBottom",offset:-2,fill:T.txd,fontSize:9}} />
            <YAxis stroke={T.txd} fontSize={10} domain={["auto","auto"]} tickFormatter={ft} tickLine={false} />
            <Tooltip content={({active,payload,label}) => {
              if (!active||!payload||!payload.length) return null;
              return (<div style={{background:T.bg,border:"1px solid "+T.bd,borderRadius:8,padding:"8px 12px",fontSize:11,boxShadow:"0 8px 24px rgba(0,0,0,0.4)"}}>
                <div style={{color:T.tx,fontWeight:700,marginBottom:4}}>Lap {label}</div>
                {allSelected.map(stnr => {
                  const row = lapTimeData[label-1];
                  if (!row || !row["t_"+stnr]) return null;
                  return (<div key={stnr} style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{width:6,height:6,borderRadius:3,background:colors[stnr],display:"inline-block"}} />
                    <span style={{color:colors[stnr],fontWeight:stnr===car?700:400}}>#{stnr}</span>
                    <span style={{color:T.tx,fontFamily:"monospace"}}>{ft(row["t_"+stnr])}</span>
                    <span style={{color:T.txd,fontSize:9}}>{row["type_"+stnr]}{row["type_"+stnr]==="PitIn"?" 🔴":""}</span>
                  </div>);
                })}
              </div>);
            }} />
            {allSelected.map(stnr => (
              <Line key={stnr} type="monotone" dataKey={"t_"+stnr} stroke={colors[stnr]}
                strokeWidth={stnr===car?2.5:1.5} strokeOpacity={stnr===car?1:0.7}
                dot={({cx,cy,payload:p}) => {
                  if (!p["t_"+stnr]) return null;
                  const isPit = p["type_"+stnr]==="PitIn";
                  const isOut = p["type_"+stnr]==="Outlap";
                  if (isPit) return <circle key={p.lap+"_"+stnr} cx={cx} cy={cy} r={5} fill={T.err} stroke={colors[stnr]} strokeWidth={2} />;
                  if (isOut) return <circle key={p.lap+"_"+stnr} cx={cx} cy={cy} r={3} fill={T.warn} stroke="none" />;
                  return <circle key={p.lap+"_"+stnr} cx={cx} cy={cy} r={stnr===car?3:2} fill={colors[stnr]} stroke="none" />;
                }} connectNulls />
            ))}
            <Legend content={() => (
              <div style={{display:"flex",gap:12,justifyContent:"center",marginTop:4}}>
                {allSelected.map(stnr => (
                  <span key={stnr} style={{fontSize:10,color:colors[stnr],fontWeight:stnr===car?700:400}}>● #{stnr}</span>
                ))}
                <span style={{fontSize:10,color:T.err}}>🔴 Pit</span>
                <span style={{fontSize:10,color:T.warn}}>🟡 Outlap</span>
              </div>
            )} />
          </ComposedChart>
        </ResponsiveContainer>
      </Panel>

      {/* Cumulative gap */}
      {rivals.length > 0 && (
        <Panel title="Cumulative Gap" sub={"Running gap vs #{"+car+"} — negative = rival is ahead, positive = you are ahead"} accent={T.ch[1]}>
          <ResponsiveContainer width="100%" height={200}>
            <ComposedChart data={gapData}>
              <CartesianGrid stroke={T.bd} strokeDasharray="3 3" />
              <XAxis dataKey="lap" stroke={T.txd} fontSize={10} tickLine={false} />
              <YAxis stroke={T.txd} fontSize={10} tickFormatter={v => (v>=0?"+":"")+v+"s"} tickLine={false} />
              <ReferenceLine y={0} stroke={T.txd} strokeDasharray="3 3" />
              <Tooltip content={({active,payload,label}) => {
                if (!active||!payload||!payload.length) return null;
                return (<div style={{background:T.bg,border:"1px solid "+T.bd,borderRadius:8,padding:"8px 12px",fontSize:11,boxShadow:"0 8px 24px rgba(0,0,0,0.4)"}}>
                  <div style={{color:T.tx,fontWeight:700,marginBottom:4}}>After Lap {label}</div>
                  {rivals.map((rStnr,i) => {
                    const row = gapData[label-1];
                    if (!row) return null;
                    const g = row["gap_"+rStnr];
                    return (<div key={rStnr} style={{display:"flex",gap:8}}>
                      <span style={{color:T.ch[i+1]}}>vs #{rStnr}</span>
                      <span style={{color:g>=0?T.ok:T.err,fontFamily:"monospace",fontWeight:700}}>{(g>=0?"+":"")+g.toFixed(1)}s</span>
                      <span style={{color:T.txd,fontSize:9}}>{g>=0?"you ahead":"rival ahead"}</span>
                    </div>);
                  })}
                </div>);
              }} />
              {rivals.map((rStnr,i) => (
                <Line key={rStnr} type="monotone" dataKey={"gap_"+rStnr} stroke={T.ch[i+1]} strokeWidth={2} dot={false} connectNulls />
              ))}
              <Legend content={() => (
                <div style={{display:"flex",gap:12,justifyContent:"center",marginTop:4}}>
                  {rivals.map((rStnr,i) => <span key={rStnr} style={{fontSize:10,color:T.ch[i+1]}}>● vs #{rStnr}</span>)}
                </div>
              )} />
            </ComposedChart>
          </ResponsiveContainer>
        </Panel>
      )}

      {/* Pit timeline */}
      {pitData.length > 0 && (
        <Panel title="Pit Stop Timeline" accent={T.err}>
          <div style={{position:"relative",padding:"8px 0"}}>
            {allSelected.map((stnr,si) => {
              const pits = pitData.filter(p=>p.stnr===stnr);
              return (
                <div key={stnr} style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                  <span style={{fontSize:10,color:colors[stnr],fontWeight:700,width:45,textAlign:"right"}}>#{stnr}</span>
                  <div style={{flex:1,height:24,background:T.bg2,borderRadius:4,position:"relative",overflow:"hidden"}}>
                    {/* Stint blocks */}
                    {(stintData.find(s=>s.stnr===stnr)?.stints||[]).map((st,idx) => {
                      const startPct = ((st.startLap-1)/maxLap)*100;
                      const endPct = (st.endLap/maxLap)*100;
                      return <div key={idx} style={{position:"absolute",left:startPct+"%",width:(endPct-startPct)+"%",top:2,bottom:2,background:colors[stnr]+"18",borderRadius:3,borderLeft:idx>0?"2px solid "+T.err:"none"}}>
                        <span style={{position:"absolute",top:3,left:4,fontSize:7,color:colors[stnr],fontWeight:600,whiteSpace:"nowrap"}}>{st.driver.split(" ")[0]}</span>
                      </div>;
                    })}
                    {/* Pit markers */}
                    {pits.map((p,pi) => (
                      <div key={pi} style={{position:"absolute",left:((p.lap/maxLap)*100)+"%",top:0,bottom:0,width:2,background:T.err}} title={"Pit R"+p.lap+" | "+p.driver} />
                    ))}
                  </div>
                  <span style={{fontSize:9,color:T.txd,width:50}}>{pits.length} pit{pits.length!==1?"s":""}</span>
                </div>
              );
            })}
            <div style={{display:"flex",justifyContent:"space-between",marginTop:2,paddingLeft:53}}>
              <span style={{fontSize:8,color:T.txd}}>Lap 1</span>
              <span style={{fontSize:8,color:T.txd}}>Lap {maxLap}</span>
            </div>
          </div>
        </Panel>
      )}

      {/* Stint comparison table */}
      <Panel title="Stint Strategy Comparison" accent={T.ac2}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:10}}>
          {stintData.map((sd,si) => (
            <div key={sd.stnr} style={{background:T.bg2,border:"1px solid "+(sd.stnr===car?T.ac+"30":T.bd),borderRadius:8,padding:10}}>
              <div style={{fontSize:12,fontWeight:700,color:colors[sd.stnr],marginBottom:6}}>#{sd.stnr} {sd.vehicle.split(" ").slice(0,3).join(" ")}</div>
              <SimpleTable headers={["St","Driver","Laps","Best","Avg"]} compact
                rows={sd.stints.map(st => (
                  <tr key={st.stint} style={{borderBottom:"1px solid "+T.bd}}>
                    <td style={{padding:"3px 6px",color:T.tx,fontWeight:600}}>{st.stint}</td>
                    <td style={{padding:"3px 6px",color:colors[sd.stnr],fontSize:9}}>{st.driver.split(" ")[0]}</td>
                    <td style={{padding:"3px 6px",color:T.txm,fontSize:10}}>{st.flyLaps}f/{st.laps}</td>
                    <td style={{padding:"3px 6px",color:T.tx,fontFamily:"monospace",fontSize:10,fontWeight:600}}>{ft(st.best)}</td>
                    <td style={{padding:"3px 6px",color:T.txm,fontFamily:"monospace",fontSize:10}}>{ft(st.avg)}</td>
                  </tr>
                ))} />
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}

/* ================================================================
   SECTOR TAB
   ================================================================ */
function SectorTab({data,car,cls}) {
  const classFly = useMemo(() => flyOnly(data.filter(d=>d.klasse===cls)), [data,cls]);
  const carFly = useMemo(() => classFly.filter(d=>d.stnr===car), [classFly,car]);
  const cbs = bestSectors(classFly);
  const abs2 = bestSectors(carFly);
  const abl = carFly.length ? minBy(carFly,"lapSec").lapSec : null;
  const cbl = classFly.length ? minBy(classFly,"lapSec").lapSec : null;
  const tg = abl && cbl ? abl - cbl : 0;

  const focusData = SL.map((label,i) => {
    const cs = abs2[i], cl = cbs[i];
    if (!cs || !cl) return {s:label,sn:SNAMES[label],gap:null,fi:null,carT:cs,clsT:cl,pct:null};
    const gap = cs - cl;
    const pct = abl ? cs/abl : 0;
    const exp = tg > 0 ? tg * pct : 0;
    const fi = exp > 0 ? gap/exp : (gap > 0 ? 2 : 0);
    return {s:label,sn:SNAMES[label],gap,fi,carT:cs,clsT:cl,pct,exp};
  });
  const sortedFocus = sortBy(focusData.filter(d => d.fi!=null && d.gap>0), d => -d.fi);
  const gapChart = focusData.filter(d => d.gap!=null).map(d => ({sector:d.s,name:d.sn,gap:+d.gap.toFixed(3),fi:d.fi?+d.fi.toFixed(2):0,fill:d.fi>1.3?T.err:d.fi>1?T.warn:T.ok}));

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
        <h3 style={{margin:0,fontSize:15,fontWeight:700,color:T.tx}}>Sector Analysis</h3>
        <Badge text={"#"+car+" vs "+cls} />
        {tg > 0 && <Badge text={"Total gap: "+fgs(tg)} color={T.err} />}
      </div>
      {sortedFocus.length > 0 && (
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:8}}>
          {sortedFocus.slice(0,3).map((d,i) => {
            const col = i===0?T.err:i===1?T.warn:T.ok;
            return (<div key={d.s} style={{background:T.sf,border:"1px solid "+col+"30",borderRadius:10,padding:12,position:"relative",overflow:"hidden"}}>
              <div style={{position:"absolute",top:0,left:0,right:0,height:2,background:col}} />
              <div style={{fontSize:10,color:T.txd,marginBottom:2}}>Focus #{i+1}</div>
              <div style={{fontSize:13,fontWeight:700,color:T.tx}}>{d.s}: {d.sn.split("/")[0].trim()}</div>
              <div style={{display:"flex",gap:12,marginTop:6,fontSize:11}}>
                <div><span style={{color:T.txd}}>Gap </span><span style={{color:col,fontFamily:"monospace",fontWeight:700}}>{fgs(d.gap)}</span></div>
                <div><span style={{color:T.txd}}>FI </span><span style={{color:col,fontFamily:"monospace",fontWeight:700}}>{d.fi.toFixed(2)}</span></div>
              </div>
            </div>);
          })}
        </div>
      )}
      <Panel title="Gap per Sector" sub="FocusIndex > 1.0 = disproportionate time loss in this sector" accent={T.ac}>
        <ResponsiveContainer width="100%" height={180}>
          <BarChart data={gapChart} layout="vertical">
            <CartesianGrid stroke={T.bd} strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" stroke={T.txd} fontSize={10} tickFormatter={v => "+"+v.toFixed(1)+"s"} />
            <YAxis type="category" dataKey="sector" stroke={T.txd} fontSize={11} width={30} />
            <Tooltip content={({active,payload}) => {
              if (!active||!payload||!payload.length) return null;
              const d = payload[0].payload;
              return (<div style={{background:T.bg,border:"1px solid "+T.bd,borderRadius:8,padding:"8px 12px",fontSize:11,boxShadow:"0 8px 24px rgba(0,0,0,0.4)"}}>
                <div style={{color:T.tx,fontWeight:700}}>{d.sector} | {d.name}</div>
                <div style={{color:T.err}}>Gap: {fgs(d.gap)}</div>
                <div style={{color:T.txm}}>FocusIndex: {d.fi}</div>
              </div>);
            }} />
            <Bar dataKey="gap" radius={[0,6,6,0]} barSize={20}>
              {gapChart.map((d,i) => <Cell key={i} fill={d.fill} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Panel>
      <Panel title="Sector Detail">
        <SimpleTable headers={["Sector","Track Section","Car","Class Best","Gap","% of Lap","Expected Gap","FI"]}
          rows={focusData.map(d => {
            const fiCol = d.fi>1.3?T.err:d.fi>1?T.warn:T.ok;
            return (<tr key={d.s} style={{borderBottom:"1px solid "+T.bd,background:d.fi>1.3?T.errg:"transparent"}}>
              <td style={{padding:"5px 8px",color:T.tx,fontWeight:700}}>{d.s}</td>
              <td style={{padding:"5px 8px",color:T.txd,fontSize:9,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.sn}</td>
              <td style={{padding:"5px 8px",color:T.ac,fontFamily:"monospace"}}>{ft(d.carT)}</td>
              <td style={{padding:"5px 8px",color:T.ok,fontFamily:"monospace"}}>{ft(d.clsT)}</td>
              <td style={{padding:"5px 8px",color:d.gap>0?T.err:T.ok,fontFamily:"monospace",fontWeight:600}}>{d.gap!=null?fgs(d.gap):"\u2013"}</td>
              <td style={{padding:"5px 8px",color:T.txm}}>{d.pct!=null?(d.pct*100).toFixed(1)+"%":"\u2013"}</td>
              <td style={{padding:"5px 8px",color:T.txm,fontFamily:"monospace"}}>{d.exp!=null?fgs(d.exp):"\u2013"}</td>
              <td style={{padding:"5px 8px",fontWeight:700,fontFamily:"monospace",color:fiCol}}>{d.fi!=null?d.fi.toFixed(2):"\u2013"}</td>
            </tr>);
          })} />
      </Panel>
    </div>
  );
}

/* ================================================================
   DRIVER TAB
   ================================================================ */
function DriverTab({data,car}) {
  const carData = useMemo(() => data.filter(d=>d.stnr===car), [data,car]);
  const flying = useMemo(() => flyOnly(carData), [carData]);
  const drivers = useMemo(() => uniq(carData.map(d=>d.activeDriver)), [carData]);
  const driverStats = useMemo(() => {
    return drivers.map(dr => {
      const allLaps = carData.filter(d=>d.activeDriver===dr);
      const laps = flying.filter(d=>d.activeDriver===dr);
      const bl = laps.length ? minBy(laps,"lapSec") : null;
      const t3 = laps.length >= 3 ? meanBy(sortBy(laps,"lapSec").slice(0,3),"lapSec") : (laps.length ? meanBy(laps,"lapSec") : null);
      const bs = bestSectors(laps);
      const tb = bs.every(s=>s!=null) ? sum(bs) : null;
      return { driver:dr, laps:laps.length, total:allLaps.length, best:bl?bl.lapSec:null, t3, tb, bs, avg: laps.length?meanBy(laps,"lapSec"):null };
    }).sort((a,b) => (a.best||999)-(b.best||999));
  }, [drivers,flying,carData]);
  const carBest = flying.length ? minBy(flying,"lapSec").lapSec : null;

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <h3 style={{margin:0,fontSize:15,fontWeight:700,color:T.tx}}>Drivers | #{car}</h3>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))",gap:10}}>
        {driverStats.map((d,i) => (
          <div key={d.driver} style={{background:T.sf,border:"1px solid "+(i===0?T.ac+"40":T.bd),borderRadius:10,padding:14,position:"relative",overflow:"hidden"}}>
            <div style={{position:"absolute",top:0,left:0,right:0,height:2,background:T.ch[i]}} />
            {i===0 && <div style={{position:"absolute",top:8,right:10,fontSize:9,color:T.ok,fontWeight:700,background:T.okg,padding:"1px 6px",borderRadius:6}}>FASTEST</div>}
            <div style={{fontSize:14,fontWeight:700,color:T.ch[i],marginBottom:8}}>{d.driver}</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,fontSize:11}}>
              <div><span style={{color:T.txd}}>Best: </span><span style={{color:T.tx,fontFamily:"monospace",fontWeight:700}}>{ft(d.best)}</span></div>
              <div><span style={{color:T.txd}}>Top3: </span><span style={{color:T.tx,fontFamily:"monospace"}}>{ft(d.t3)}</span></div>
              <div><span style={{color:T.txd}}>Theo: </span><span style={{color:T.tx,fontFamily:"monospace"}}>{ft(d.tb)}</span></div>
              <div><span style={{color:T.txd}}>Gap: </span><span style={{color:d.best===carBest?T.ok:T.warn,fontFamily:"monospace",fontWeight:600}}>{carBest?fgs(d.best-carBest):"\u2013"}</span></div>
              <div><span style={{color:T.txd}}>Avg: </span><span style={{color:T.txm,fontFamily:"monospace"}}>{ft(d.avg)}</span></div>
              <div><span style={{color:T.txd}}>Laps: </span><span style={{color:T.txm}}>{d.laps} fly / {d.total}</span></div>
            </div>
          </div>
        ))}
      </div>
      <Panel title="Sector Comparison" accent={T.ac}>
        <SimpleTable headers={["Driver",...SL,"Best Lap"]}
          rows={driverStats.map((d,di) => (
            <tr key={d.driver} style={{borderBottom:"1px solid "+T.bd}}>
              <td style={{padding:"5px 8px",color:T.ch[di],fontWeight:700,fontSize:11}}>{d.driver}</td>
              {d.bs.map((s,si) => {
                const all = driverStats.map(x=>x.bs[si]).filter(x=>x!=null);
                const isBest = s!=null && all.length>1 && s===Math.min(...all);
                return <td key={si} style={{padding:"5px 8px",fontFamily:"monospace",fontWeight:isBest?700:400,color:isBest?T.ok:T.txm,background:isBest?T.okg:"transparent"}}>{ft(s)}</td>;
              })}
              <td style={{padding:"5px 8px",fontFamily:"monospace",fontWeight:700,color:di===0?T.ac:T.tx}}>{ft(d.best)}</td>
            </tr>
          ))} />
      </Panel>
    </div>
  );
}

/* ================================================================
   CLASS TAB
   ================================================================ */
function ClassTab({data,cls,car}) {
  const classFly = useMemo(() => flyOnly(data.filter(d=>d.klasse===cls)), [data,cls]);
  const carStats = useMemo(() => {
    const g = groupBy(classFly,"stnr");
    return Object.entries(g).map(([s,laps]) => {
      const bl = minBy(laps,"lapSec");
      const t3 = laps.length>=3 ? meanBy(sortBy(laps,"lapSec").slice(0,3),"lapSec") : meanBy(laps,"lapSec");
      const bs = bestSectors(laps);
      const tb = bs.every(s=>s!=null) ? sum(bs) : null;
      return { stnr:+s, vehicle:laps[0].vehicle, team:laps[0].team, drivers:uniq(laps.map(l=>l.activeDriver)), laps:laps.length, best:bl.lapSec, t3, tb, bs };
    }).sort((a,b) => (a.best||999)-(b.best||999));
  }, [classFly]);
  const classBest = carStats.length ? carStats[0].best : null;

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
        <h3 style={{margin:0,fontSize:15,fontWeight:700,color:T.tx}}>Class | {cls}</h3>
        <Badge text={carStats.length+" cars"} color={T.txm} />
      </div>
      <Panel title="Gap to Class Best" accent={T.ac}>
        <ResponsiveContainer width="100%" height={Math.max(160,carStats.length*26)}>
          <BarChart data={carStats.map(c => ({name:"#"+c.stnr,gap:c.best&&classBest?+(c.best-classBest).toFixed(3):0,best:c.best,sel:c.stnr===car}))} layout="vertical">
            <CartesianGrid stroke={T.bd} strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" stroke={T.txd} fontSize={10} tickFormatter={v => "+"+v.toFixed(1)+"s"} />
            <YAxis type="category" dataKey="name" stroke={T.txd} fontSize={10} width={46} />
            <Tooltip content={({active,payload}) => {
              if (!active||!payload||!payload.length) return null;
              const d = payload[0].payload;
              return (<div style={{background:T.bg,border:"1px solid "+T.bd,borderRadius:8,padding:"8px 12px",fontSize:11}}><div style={{color:T.tx,fontWeight:700}}>{d.name}</div><div style={{color:T.ac,fontFamily:"monospace"}}>{ft(d.best)}</div></div>);
            }} />
            <Bar dataKey="gap" radius={[0,6,6,0]} barSize={16}>
              {carStats.map((c,i) => <Cell key={i} fill={c.stnr===car?T.ac:T.ch[3]} fillOpacity={c.stnr===car?1:0.4} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Panel>
      <Panel title="Ranking">
        <SimpleTable headers={["P","#","Vehicle","Team","Laps","Best","Top3","Gap"]}
          rows={carStats.map((c,i) => {
            const sel = c.stnr===car;
            return (<tr key={c.stnr} style={{borderBottom:"1px solid "+T.bd,background:sel?T.acg:"transparent"}}>
              <td style={{padding:"5px 7px",color:i<3?T.ac:T.txm,fontWeight:700}}>{i+1}</td>
              <td style={{padding:"5px 7px",color:sel?T.ac:T.tx,fontWeight:700,fontFamily:"monospace"}}>{c.stnr}</td>
              <td style={{padding:"5px 7px",color:T.txm,fontSize:10,maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.vehicle}</td>
              <td style={{padding:"5px 7px",color:T.txd,fontSize:9,maxWidth:120,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.team}</td>
              <td style={{padding:"5px 7px",color:T.txd}}>{c.laps}</td>
              <td style={{padding:"5px 7px",fontFamily:"monospace",fontWeight:600,color:sel?T.ac:T.tx}}>{ft(c.best)}</td>
              <td style={{padding:"5px 7px",fontFamily:"monospace",color:T.txm}}>{ft(c.t3)}</td>
              <td style={{padding:"5px 7px",fontFamily:"monospace",color:i===0?T.ok:T.warn}}>{classBest?fgs(c.best-classBest):"\u2013"}</td>
            </tr>);
          })} />
      </Panel>
    </div>
  );
}

/* ================================================================
   RADAR TAB
   ================================================================ */
function RadarTab({data,cls,car}) {
  const classFly = useMemo(() => flyOnly(data.filter(d=>d.klasse===cls)), [data,cls]);
  const allCars = useMemo(() => sortBy(uniq(classFly.map(d=>d.stnr))), [classFly]);
  const [sel,setSel] = useState([]);
  useEffect(() => { setSel([car,...allCars.filter(c=>c!==car).slice(0,3)].slice(0,5)); }, [allCars,car]);
  const toggle = stnr => setSel(p => p.includes(stnr)?p.filter(x=>x!==stnr):p.length<5?[...p,stnr]:p);

  const carStatsR = useMemo(() => sel.map(stnr => {
    const laps = classFly.filter(d=>d.stnr===stnr);
    return { stnr, bs:bestSectors(laps), bl:laps.length?minBy(laps,"lapSec").lapSec:null, vehicle:laps[0]?laps[0].vehicle:"" };
  }), [sel,classFly]);

  const radarData = useMemo(() => {
    const allS = SL.map((_,i) => carStatsR.map(c=>c.bs[i]).filter(x=>x!=null));
    return SL.map((label,i) => {
      const vals = allS[i];
      if (!vals.length) return {sector:label};
      const mn = Math.min(...vals), mx = Math.max(...vals), rng = mx-mn||1;
      const obj = {sector:label};
      carStatsR.forEach(c => { if (c.bs[i]!=null) obj["#"+c.stnr] = +((1-(c.bs[i]-mn)/rng)*100).toFixed(1); });
      return obj;
    });
  }, [carStatsR]);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <h3 style={{margin:0,fontSize:15,fontWeight:700,color:T.tx}}>Radar | {cls}</h3>
      <Panel title="Select cars (max 5)" accent={T.ac}>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {allCars.map(s => {
            const a = sel.includes(s);
            return <button key={s} onClick={()=>toggle(s)} style={{padding:"3px 10px",fontSize:10,fontWeight:a?700:400,borderRadius:5,border:"1px solid "+(a?T.ac:T.bd),background:a?T.acg:"transparent",color:a?T.ac:T.txm,cursor:"pointer"}}>#{s}</button>;
          })}
        </div>
      </Panel>
      {sel.length>=2 && (
        <Panel title="Sector Radar" sub="Higher = faster (normalized within selection)">
          <ResponsiveContainer width="100%" height={320}>
            <RadarChart data={radarData}>
              <PolarGrid stroke={T.bd} />
              <PolarAngleAxis dataKey="sector" tick={{fill:T.txm,fontSize:11}} />
              <PolarRadiusAxis tick={{fill:T.txd,fontSize:9}} domain={[0,100]} />
              {carStatsR.map((c,i) => <Radar key={c.stnr} name={"#"+c.stnr} dataKey={"#"+c.stnr} stroke={T.ch[i]} fill={T.ch[i]} fillOpacity={0.06} strokeWidth={2} />)}
              <Legend wrapperStyle={{fontSize:10}} />
            </RadarChart>
          </ResponsiveContainer>
        </Panel>
      )}
    </div>
  );
}

/* ================================================================
   COACHING TAB
   ================================================================ */
function CoachingTab({data,car,cls}) {
  const classFly = useMemo(() => flyOnly(data.filter(d=>d.klasse===cls)), [data,cls]);
  const carFly = useMemo(() => classFly.filter(d=>d.stnr===car), [classFly,car]);
  const drivers = useMemo(() => uniq(carFly.map(d=>d.activeDriver)), [carFly]);
  const cbs = bestSectors(classFly);
  const clBest = classFly.length ? minBy(classFly,"lapSec").lapSec : null;

  const cards = useMemo(() => {
    const result = [];
    drivers.forEach(dr => {
      const laps = carFly.filter(d=>d.activeDriver===dr);
      const bl = laps.length ? minBy(laps,"lapSec").lapSec : null;
      const totalGap = bl && clBest ? bl - clBest : 0;
      SL.forEach((sl,i) => {
        const valid = laps.filter(d=>d.sectors[i]!=null);
        if (!valid.length) return;
        const best = minBy(valid,d=>d.sectors[i]).sectors[i];
        const clS = cbs[i];
        if (!clS || !best || !bl) return;
        const gap = best - clS;
        const pct = best/bl;
        const exp = totalGap>0 ? totalGap*pct : 0;
        const fi = exp>0 ? gap/exp : (gap>0?2:0);
        if (gap > 0.2) {
          const tips = {S1:["Check braking zone Hatzenbach","Line through chicane","Acceleration out of Nordkehre"],S2:["Top speed Flugplatz","Line Aremberg","Braking Fuchsrohre"],S3:["Schwedenkreuz entry speed","Braking Adenauer Forst","Acceleration out of Metzgesfeld"],S4:["Karussell speed and line","Braking Hohe Acht","Galgenkopf exit speed"],S5:["Top speed Dottinger Hohe","T13 entry line","Braking zone Gantry"]};
          result.push({driver:dr,sector:sl,sn:SNAMES[sl],gap,fi,best,cl:clS,prio:fi>1.3?"high":fi>1?"medium":"low",tips:tips[sl]||[]});
        }
      });
    });
    return sortBy(result, x => -x.fi);
  }, [drivers,carFly,classFly,cbs,clBest]);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
        <h3 style={{margin:0,fontSize:15,fontWeight:700,color:T.tx}}>Coaching | #{car}</h3>
        <Badge text={cards.filter(c=>c.prio==="high").length+" high priority"} color={T.err} />
      </div>
      {cards.length===0 && <Panel><p style={{color:T.txm,fontSize:12,margin:0}}>No significant gaps found. Strong performance!</p></Panel>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:10}}>
        {cards.slice(0,12).map((c,i) => {
          const borderCol = c.prio==="high"?T.err:c.prio==="medium"?T.warn:T.ok;
          return (<div key={i} style={{background:T.sf,border:"1px solid "+borderCol+"40",borderRadius:10,padding:14,position:"relative",overflow:"hidden"}}>
            <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:borderCol}} />
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <span style={{fontSize:12,fontWeight:700,color:T.ch[drivers.indexOf(c.driver)%T.ch.length]}}>{c.driver}</span>
              <Badge text={c.prio} color={borderCol} />
            </div>
            <div style={{fontSize:13,fontWeight:700,color:T.tx,marginBottom:6}}>{c.sector}: {c.sn.split("/")[0].trim()}</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,fontSize:11,marginBottom:8}}>
              <div><span style={{color:T.txd}}>Gap </span><span style={{color:T.err,fontFamily:"monospace",fontWeight:700}}>{fgs(c.gap)}</span></div>
              <div><span style={{color:T.txd}}>You </span><span style={{color:T.tx,fontFamily:"monospace"}}>{ft(c.best)}</span></div>
              <div><span style={{color:T.txd}}>Best </span><span style={{color:T.ok,fontFamily:"monospace"}}>{ft(c.cl)}</span></div>
            </div>
            <div style={{fontSize:10,color:T.txm,lineHeight:1.5,background:T.acg,padding:"8px 10px",borderRadius:6}}>
              <strong style={{color:T.ac}}>Action:</strong> FI {c.fi.toFixed(2)} — {c.fi>1.3?"Priority! ":c.fi>1?"Above expected. ":"Within margin. "}
              {c.tips.slice(0,2).join(". ")}.
            </div>
          </div>);
        })}
      </div>
    </div>
  );
}

/* ================================================================
   COMPARE TAB (cross-race / cross-car)
   ================================================================ */
function CompareTab({races,activeRace}) {
  const [selRaces, setSelRaces] = useState([]);
  const [selCars, setSelCars] = useState([]);
  const [selClass, setSelClass] = useState("");

  useEffect(() => {
    if (races.length) {
      setSelRaces(races.map((_,i)=>i));
      const allClasses = uniq(races.flatMap(r=>r.data.map(d=>d.klasse))).sort();
      const dc = allClasses.find(c=>c.includes("M240i")) || allClasses[0] || "";
      setSelClass(dc);
    }
  }, [races]);

  const allClasses = useMemo(() => uniq(races.flatMap(r=>r.data.map(d=>d.klasse))).sort(), [races]);
  const availableCars = useMemo(() => {
    const cars = new Map();
    selRaces.forEach(ri => {
      if (!races[ri]) return;
      races[ri].data.filter(d=>d.klasse===selClass).forEach(d => {
        if (!cars.has(d.stnr)) cars.set(d.stnr, d.vehicle);
      });
    });
    return sortBy([...cars.entries()].map(([stnr,v]) => ({stnr,vehicle:v})), "stnr");
  }, [selRaces,races,selClass]);

  const toggleCar = stnr => setSelCars(p => p.includes(stnr)?p.filter(x=>x!==stnr):p.length<6?[...p,stnr]:p);

  const compareData = useMemo(() => {
    return selCars.map(stnr => {
      const raceResults = selRaces.map(ri => {
        if (!races[ri]) return null;
        const laps = flyOnly(races[ri].data.filter(d=>d.stnr===stnr&&d.klasse===selClass));
        if (!laps.length) return null;
        const bl = minBy(laps,"lapSec").lapSec;
        const bs = bestSectors(laps);
        return { race:races[ri].name, best:bl, bs, weather:races[ri].weather, temp:races[ri].temp };
      }).filter(Boolean);
      return { stnr, vehicle: availableCars.find(c=>c.stnr===stnr)?.vehicle||"", raceResults };
    }).filter(c=>c.raceResults.length>0);
  }, [selCars,selRaces,races,selClass,availableCars]);

  if (races.length < 1) return <Panel><p style={{color:T.txm,fontSize:12,margin:0}}>Upload races in the Race Manager to compare.</p></Panel>;

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <h3 style={{margin:0,fontSize:15,fontWeight:700,color:T.tx}}>Compare</h3>
      <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"flex-end"}}>
        <Sel label="Class" value={selClass} onChange={v => { setSelClass(v); setSelCars([]); }} options={allClasses.map(c=>({value:c,label:c}))} w={120} />
        <div style={{display:"flex",flexDirection:"column",gap:3}}>
          <label style={{fontSize:9,color:T.txm,textTransform:"uppercase",fontWeight:700}}>Races</label>
          <div style={{display:"flex",gap:4}}>
            {races.map((r,i) => {
              const a = selRaces.includes(i);
              return <button key={i} onClick={()=>setSelRaces(p=>a?p.filter(x=>x!==i):[...p,i])} style={{padding:"3px 10px",fontSize:10,fontWeight:a?700:400,borderRadius:5,border:"1px solid "+(a?T.ac:T.bd),background:a?T.acg:"transparent",color:a?T.ac:T.txm,cursor:"pointer"}}>{r.name}</button>;
            })}
          </div>
        </div>
      </div>
      <Panel title={"Select cars to compare (max 6) | "+selClass} accent={T.ac}>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {availableCars.map(c => {
            const a = selCars.includes(c.stnr);
            return <button key={c.stnr} onClick={()=>toggleCar(c.stnr)} style={{padding:"3px 10px",fontSize:10,fontWeight:a?700:400,borderRadius:5,border:"1px solid "+(a?T.ac:T.bd),background:a?T.acg:"transparent",color:a?T.ac:T.txm,cursor:"pointer"}}>#{c.stnr}</button>;
          })}
        </div>
      </Panel>
      {compareData.length > 0 && (
        <>
          <Panel title="Best Lap Comparison">
            <SimpleTable headers={["#","Vehicle",...selRaces.filter(ri=>races[ri]).map(ri=>{const r=races[ri];return r.name+(r.weather!=="dry"?" "+(r.weather==="wet"?"🌧️":"⛅"):"")+(r.temp?" "+r.temp:"");})]}
              rows={compareData.map((c,ci) => (
                <tr key={c.stnr} style={{borderBottom:"1px solid "+T.bd}}>
                  <td style={{padding:"5px 8px",color:T.ch[ci],fontWeight:700,fontFamily:"monospace"}}>{c.stnr}</td>
                  <td style={{padding:"5px 8px",color:T.txm,fontSize:10}}>{c.vehicle}</td>
                  {selRaces.filter(ri=>races[ri]).map(ri => {
                    const rr = c.raceResults.find(r=>r.race===races[ri].name);
                    return <td key={ri} style={{padding:"5px 8px",fontFamily:"monospace",color:rr?T.tx:T.txd,fontWeight:600}}>{rr?ft(rr.best):"\u2013"}</td>;
                  })}
                </tr>
              ))} />
          </Panel>
          {compareData.length >= 1 && selRaces.length >= 2 && (
            <Panel title="Progression" accent={T.ch[1]}>
              <ResponsiveContainer width="100%" height={220}>
                <LineChart data={selRaces.filter(ri=>races[ri]).map(ri => {
                  const o = {race:races[ri].name};
                  compareData.forEach(c => { const rr=c.raceResults.find(r=>r.race===races[ri].name); o["#"+c.stnr]=rr?rr.best:null; });
                  return o;
                })}>
                  <CartesianGrid stroke={T.bd} strokeDasharray="3 3" />
                  <XAxis dataKey="race" stroke={T.txd} fontSize={10} />
                  <YAxis stroke={T.txd} fontSize={10} domain={["auto","auto"]} tickFormatter={ft} />
                  {compareData.map((c,i) => <Line key={c.stnr} dataKey={"#"+c.stnr} stroke={T.ch[i]} strokeWidth={2} dot={{r:4}} connectNulls />)}
                  <Legend wrapperStyle={{fontSize:10}} />
                </LineChart>
              </ResponsiveContainer>
            </Panel>
          )}
        </>
      )}
    </div>
  );
}

/* ================================================================
   DETAIL TAB
   ================================================================ */
function DetailTab({data,car}) {
  const carData = useMemo(() => data.filter(d=>d.stnr===car), [data,car]);
  const flying = useMemo(() => flyOnly(carData), [carData]);
  const bl = flying.length ? minBy(flying,"lapSec").lapSec : null;
  const bsl = bestSectors(flying);
  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <h3 style={{margin:0,fontSize:15,fontWeight:700,color:T.tx}}>Detail | #{car}</h3>
      <Panel>
        <SimpleTable headers={["Lap","Driver","Type","St","LiS","Time",...SL]} compact
          rows={carData.map(d => {
            const isBest = d.lapType==="Flying"&&d.lapSec===bl;
            return (<tr key={d.lapNr} style={{borderBottom:"1px solid "+T.bd,background:isBest?T.acg:d.lapType==="PitIn"?T.errg:"transparent"}}>
              <td style={{padding:"3px 6px",color:T.tx,fontWeight:600}}>{d.lapNr}</td>
              <td style={{padding:"3px 6px",color:T.ac,fontSize:9}}>{d.activeDriver}</td>
              <td style={{padding:"3px 6px",fontSize:9,color:d.lapType==="Flying"?T.ok:d.lapType==="PitIn"?T.err:T.warn}}>{d.lapType}</td>
              <td style={{padding:"3px 6px",color:T.txm}}>{d.stint}</td>
              <td style={{padding:"3px 6px",color:T.txm}}>{d.lapInStint}</td>
              <td style={{padding:"3px 6px",color:isBest?T.ac:T.tx,fontFamily:"monospace",fontWeight:isBest?700:400}}>{ft(d.lapSec)}</td>
              {SL.map((_,i) => {
                const isSB = d.sectors[i]!=null&&bsl[i]!=null&&d.sectors[i]===bsl[i];
                return <td key={i} style={{padding:"3px 6px",fontFamily:"monospace",color:isSB?T.ok:T.txm,fontWeight:isSB?700:400,background:isSB?T.okg:"transparent"}}>{ft(d.sectors[i])}</td>;
              })}
            </tr>);
          })} />
      </Panel>
    </div>
  );
}

/* ================================================================
   GUIDE TAB
   ================================================================ */
function GuideTab() {
  const Section = ({title,children}) => (
    <div style={{marginBottom:20}}>
      <h4 style={{margin:"0 0 8px",fontSize:13,fontWeight:700,color:T.ac}}>{title}</h4>
      <div style={{fontSize:11,color:T.txm,lineHeight:1.7}}>{children}</div>
    </div>
  );
  const MockScreen = ({title,desc,children}) => (
    <div style={{background:T.bg2,border:"1px solid "+T.bd,borderRadius:10,padding:14,marginBottom:12}}>
      <div style={{fontSize:11,fontWeight:700,color:T.tx,marginBottom:4}}>{title}</div>
      {desc && <div style={{fontSize:10,color:T.txd,marginBottom:8}}>{desc}</div>}
      {children}
    </div>
  );
  const MockKPI = ({label,value,color}) => (
    <div style={{background:T.sf,border:"1px solid "+T.bd,borderRadius:6,padding:"6px 10px",minWidth:80,display:"inline-block",marginRight:6,marginBottom:4}}>
      <div style={{fontSize:8,color:T.txm,textTransform:"uppercase"}}>{label}</div>
      <div style={{fontSize:14,fontWeight:700,color:color||T.ac,fontFamily:"monospace"}}>{value}</div>
    </div>
  );
  const MockBar = ({label,width,color}) => (
    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
      <span style={{fontSize:10,color:T.txm,width:30,textAlign:"right"}}>{label}</span>
      <div style={{height:12,borderRadius:3,background:color||T.ac,width:width+"%",maxWidth:"100%",transition:"width 0.3s"}} />
    </div>
  );

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14,maxWidth:700}}>
      <h3 style={{margin:0,fontSize:16,fontWeight:700,color:T.tx}}>User Guide</h3>

      <Section title="1. Getting Started — Race Manager">
        <p>When you first open the app, you'll see the <strong style={{color:T.tx}}>Race Manager</strong>. This is where you upload and manage your CSV files.</p>
        <MockScreen title="📂 Race Manager" desc="Upload area and race list">
          <div style={{border:"2px dashed "+T.bd,borderRadius:8,padding:"14px",textAlign:"center",marginBottom:8}}>
            <div style={{fontSize:10,color:T.txd}}>Drop CSV files here or click to upload</div>
          </div>
          <div style={{background:T.sf,border:"1px solid "+T.ac+"40",borderRadius:8,padding:10}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <span style={{fontSize:11,fontWeight:700,color:T.tx}}>NLS Race 2</span>
              <Badge text="ACTIVE" color={T.ac} />
            </div>
            <div style={{display:"flex",gap:8,fontSize:9,color:T.txd,marginBottom:6}}><span>142 cars</span><span>2900 laps</span><span>22 classes</span></div>
            <div style={{display:"flex",gap:4}}>
              <span style={{padding:"2px 8px",fontSize:9,borderRadius:4,background:T.okg,color:T.ok,border:"1px solid "+T.ok+"30"}}>☀️ Dry</span>
              <span style={{padding:"2px 8px",fontSize:9,borderRadius:4,background:T.sf,color:T.txm,border:"1px solid "+T.bd}}>🌧️ Wet</span>
              <span style={{padding:"2px 8px",fontSize:9,borderRadius:4,background:T.sf,color:T.txm,border:"1px solid "+T.bd}}>⛅ Mixed</span>
              <span style={{fontSize:9,color:T.txd,padding:"2px 4px"}}>🌡️ 18°C</span>
            </div>
          </div>
        </MockScreen>
        <p><strong style={{color:T.tx}}>Weather & Temperature:</strong> The CSV file does not contain reliable weather data. Set the conditions manually for each race: Dry, Wet, or Mixed. Optionally add the track temperature. This metadata travels with the race in the Compare tab.</p>
        <p><strong style={{color:T.tx}}>Multiple races:</strong> Upload several CSV files to enable the Season and Compare tabs. Each race can be renamed by clicking its name.</p>
      </Section>

      <Section title="2. Header Bar Controls">
        <MockScreen title="Header bar">
          <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",fontSize:10}}>
            <div style={{display:"flex",flexDirection:"column"}}><span style={{fontSize:8,color:T.txm}}>CLASS</span><span style={{color:T.tx,background:T.sf,padding:"2px 6px",borderRadius:3,border:"1px solid "+T.bd}}>BMW M240i</span></div>
            <div style={{display:"flex",flexDirection:"column"}}><span style={{fontSize:8,color:T.txm}}>CAR</span><span style={{color:T.tx,background:T.sf,padding:"2px 6px",borderRadius:3,border:"1px solid "+T.bd}}>#665 — BMW M240i Racing Cup</span></div>
            <div style={{display:"flex",flexDirection:"column"}}><span style={{fontSize:8,color:T.txm}}>HIGHLIGHT</span><span style={{color:T.ac,background:T.bg,padding:"2px 6px",borderRadius:3,border:"1px solid "+T.bd,fontFamily:"monospace"}}>665</span></div>
          </div>
        </MockScreen>
        <p><strong style={{color:T.tx}}>Class:</strong> Filter all data by class. Every tab only shows data from this class.</p>
        <p><strong style={{color:T.tx}}>Car:</strong> The primary car being analyzed. All Dashboard, Sector, Driver, and Coaching data relates to this car.</p>
        <p><strong style={{color:T.ac}}>Highlight (HL):</strong> This is a <strong>visual marker</strong>. Enter any car number and it gets highlighted in charts and tables across the app — colored bar in Class rankings, bold in comparisons. Use it to spot your own car when browsing other cars' data, or to track a competitor. It does NOT filter data — it only highlights visually.</p>
      </Section>

      <Section title="3. Dashboard">
        <MockScreen title="Dashboard — Performance Overview">
          <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:8}}>
            <MockKPI label="Best Lap" value="9:23.532" />
            <MockKPI label="Top 3 Avg" value="9:28.104" color={T.ok} />
            <MockKPI label="Theo. Best" value="9:18.771" color={T.warn} />
            <MockKPI label="Gap to Class" value="+12.450s" color={T.err} />
          </div>
          <div style={{fontSize:9,color:T.txd}}>Lap time chart and stint breakdown shown below KPIs</div>
        </MockScreen>
        <p><strong style={{color:T.tx}}>Best Lap:</strong> Fastest flying lap (excludes pit-in laps and outlaps).</p>
        <p><strong style={{color:T.tx}}>Top 3 Average:</strong> Mean of the 3 fastest flying laps. More representative of consistent pace.</p>
        <p><strong style={{color:T.tx}}>Theoretical Best:</strong> Sum of best sector times. Shows the potential if you could combine all your best sectors.</p>
        <p><strong style={{color:T.tx}}>Potential:</strong> Best Lap minus Theoretical Best. The time still "left on the table".</p>
      </Section>

      <Section title="4. Head-to-Head — Head-to-Head Comparison">
        <MockScreen title="Head-to-Head — Lap Time Overlay">
          <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:6}}>
            <span style={{fontSize:10,color:T.ac,fontWeight:700,padding:"2px 8px",borderRadius:4,background:T.acg}}>#{665} (you)</span>
            <span style={{fontSize:10,color:T.ch[1],fontWeight:700,padding:"2px 8px",borderRadius:4,background:T.ch[1]+"15"}}>#{670}</span>
            <span style={{fontSize:10,color:T.ch[2],fontWeight:700,padding:"2px 8px",borderRadius:4,background:T.ch[2]+"15"}}>#{680}</span>
          </div>
          <div style={{display:"flex",gap:6,alignItems:"flex-end",height:50,marginBottom:4}}>
            {[38,35,42,34,36,55,33,35,37,34,36,33,35,52,34,36,33].map((h,i) => (
              <div key={i} style={{width:8,height:h,borderRadius:2,background:i===5||i===13?T.err:T.ac,opacity:0.7}} />
            ))}
          </div>
          <div style={{fontSize:9,color:T.txd}}>Overlaid lap times with pit-in markers (red spikes) | Cumulative gap chart below</div>
        </MockScreen>
        <p>Head-to-Head lets you compare the <strong style={{color:T.tx}}>full race progression</strong> of your car against up to 3 rivals from the same class. It shows four key views:</p>
        <p><strong style={{color:T.tx}}>Lap Times Overlay:</strong> All cars plotted on the same chart. Flying laps appear as regular dots, pit-in laps as red circles (spikes in the line), outlaps as yellow dots. Instantly see who is faster in which phase of the race.</p>
        <p><strong style={{color:T.tx}}>Cumulative Gap:</strong> A running total of the lap time difference. If the line goes up, you're pulling away from the rival. If it goes down, the rival is gaining. Crossing zero means the lead changed. This reveals pace trends, the effect of pit stops, and strategy impact.</p>
        <p><strong style={{color:T.tx}}>Pit Stop Timeline:</strong> Visual bars showing each car's stints with driver names, and red markers at pit stop laps. Compare pit timing — did you pit too early? Did the rival gain track position with a longer first stint?</p>
        <p><strong style={{color:T.tx}}>Stint Strategy:</strong> Side-by-side stint tables showing laps, driver, best and average pace per stint. Compare stint length and pace degradation.</p>
        <p>The tool auto-selects your closest rivals (by best lap) but you can pick any car in the class.</p>
      </Section>

      <Section title="5. Sectors — FocusIndex Explained">
        <MockScreen title="Sector Analysis — Focus Areas">
          <div style={{marginBottom:8}}>
            <MockBar label="S1" width={20} color={T.ok} />
            <MockBar label="S2" width={35} color={T.warn} />
            <MockBar label="S3" width={15} color={T.ok} />
            <MockBar label="S4" width={60} color={T.err} />
            <MockBar label="S5" width={25} color={T.warn} />
          </div>
          <div style={{fontSize:9,color:T.txd}}>Red = FI &gt; 1.3 (priority) | Yellow = FI &gt; 1.0 | Green = within expectations</div>
        </MockScreen>
        <p>The <strong style={{color:T.ac}}>FocusIndex (FI)</strong> answers: "Where am I losing <em>more time than expected</em>?"</p>
        <p><strong style={{color:T.tx}}>How it works:</strong> If your total gap to class best is 12s, and sector S4 represents 38% of your lap, you'd "expect" to lose 38% × 12s = 4.56s there. If you actually lose 7.2s, your FI = 7.2 / 4.56 = 1.58 — meaning S4 costs disproportionately more.</p>
        <p><strong style={{color:T.err}}>FI &gt; 1.3</strong> = Priority focus area. <strong style={{color:T.warn}}>FI 1.0–1.3</strong> = Above expected. <strong style={{color:T.ok}}>FI &lt; 1.0</strong> = Within margin or strong sector.</p>
      </Section>

      <Section title="6. Drivers — Internal Comparison">
        <p>Compares all drivers who drove the selected car. Shows best lap, top-3 average, theoretical best, and sector-by-sector times. Green highlighting marks the fastest driver per sector. Use this to understand each driver's strengths and weaknesses.</p>
      </Section>

      <Section title="7. Class — Competitive Ranking">
        <p>Full ranking of all cars in the selected class. The horizontal bar chart shows the gap of each car to the class leader. Your selected car is highlighted in cyan. Use this to understand where you stand and who your direct competitors are.</p>
      </Section>

      <Section title="8. Radar — Multi-Car Sector Comparison">
        <p>Select up to 5 cars and see a radar chart comparing their sector performance. Values are normalized: 100 = fastest in selection, 0 = slowest. This reveals each car's relative strengths across the 5 Nordschleife sectors.</p>
      </Section>

      <Section title="9. Coaching — Actionable Insights">
        <p>Combines sector analysis with driver data to produce priority cards. Each card shows a specific driver-sector combination where significant time is being lost, sorted by FocusIndex. Includes Nordschleife-specific coaching tips per sector.</p>
      </Section>

      <Section title="10. Compare — Cross-Race Analysis">
        <p>Select multiple races, a class, and up to 6 cars to compare progression across races. The weather and temperature you set in the Race Manager are shown here, so you can contextualize pace differences between dry and wet races.</p>
      </Section>

      <Section title="11. Detail — Raw Lap Data">
        <p>Complete lap-by-lap breakdown for the selected car. Green highlighting marks best sector times. Red background marks pit-in laps. Use this for deep-dive analysis of specific laps.</p>
      </Section>

      <Section title="12. Export">
        <p>The Export button generates a downloadable HTML report for the selected car with KPIs and sector analysis. Share with drivers or sponsors.</p>
      </Section>

      <Panel title="Definitions" accent={T.ac}>
        <SimpleTable headers={["Term","Meaning"]} compact
          rows={[
            ["Best Lap","Fastest flying lap (no pit-in/outlap)"],
            ["Top 3 Avg","Average of 3 fastest flying laps"],
            ["Theoretical Best","Sum of personal best sector times"],
            ["Potential","Best Lap − Theoretical Best"],
            ["Gap to Class","Your best lap − class leader's best lap"],
            ["FocusIndex (FI)","Actual sector gap ÷ expected sector gap"],
            ["Flying Lap","A full lap without pit entry or exit"],
            ["PitIn","Lap where the car entered the pit"],
            ["Outlap","First lap after leaving the pit"],
            ["Stint","Consecutive laps between pit stops"],
          ].map(([t,m]) => (
            <tr key={t} style={{borderBottom:"1px solid "+T.bd}}>
              <td style={{padding:"4px 8px",color:T.ac,fontWeight:700,whiteSpace:"nowrap"}}>{t}</td>
              <td style={{padding:"4px 8px",color:T.txm}}>{m}</td>
            </tr>
          ))} />
      </Panel>
    </div>
  );
}

/* ================================================================
   EXPORT FUNCTION (fixed)
   ================================================================ */
function doExport(data,car,cls) {
  const cf = flyOnly(data.filter(d=>d.klasse===cls));
  const carF = cf.filter(d=>d.stnr===car);
  const bl = carF.length ? minBy(carF,"lapSec") : null;
  const cb = cf.length ? minBy(cf,"lapSec") : null;
  const drs = uniq(carF.map(d=>d.activeDriver));
  const cbs = bestSectors(cf);
  const abs2 = bestSectors(carF);
  const v = carF[0]?carF[0].vehicle:"";
  const tm = carF[0]?carF[0].team:"";
  const t3 = carF.length>=3 ? meanBy(sortBy(carF,"lapSec").slice(0,3),"lapSec") : (carF.length?meanBy(carF,"lapSec"):null);
  const tb = abs2.every(s=>s!=null) ? sum(abs2) : null;

  const lines = [];
  lines.push("<!DOCTYPE html>");
  lines.push("<html><head><meta charset='utf-8'><title>Race Report #"+car+"</title>");
  lines.push("<style>");
  lines.push("*{margin:0;padding:0;box-sizing:border-box}");
  lines.push("body{font-family:Arial,sans-serif;max-width:860px;margin:0 auto;padding:30px;color:#1a1a2e;background:#f8fafc}");
  lines.push("h1{color:#09090B;border-bottom:3px solid #DC2626;padding-bottom:12px;margin-bottom:8px;font-size:22px}");
  lines.push("h2{color:#52525B;margin-top:28px;margin-bottom:10px;font-size:16px}");
  lines.push(".sub{color:#64748b;margin-bottom:20px;font-size:13px}");
  lines.push("table{width:100%;border-collapse:collapse;margin:12px 0;font-size:12px}");
  lines.push("th,td{padding:8px 12px;text-align:left;border-bottom:1px solid #e2e8f0}");
  lines.push("th{background:#f1f5f9;font-weight:700;font-size:10px;color:#64748b;text-transform:uppercase}");
  lines.push(".kpis{display:flex;gap:12px;flex-wrap:wrap;margin:16px 0}");
  lines.push(".kpi{border:2px solid #e2e8f0;border-radius:10px;padding:14px 20px;min-width:140px;text-align:center;background:#fff}");
  lines.push(".kpi .v{font-size:20px;font-weight:800;color:#09090B;font-family:monospace}");
  lines.push(".kpi .l{font-size:10px;color:#94a3b8;text-transform:uppercase;margin-bottom:4px}");
  lines.push(".pos{color:#10b981}.neg{color:#ef4444}.mono{font-family:monospace}");
  lines.push("</style></head><body>");

  lines.push("<h1>Race Report | #"+car+"</h1>");
  lines.push("<p class='sub'><b>Class:</b> "+cls+" | <b>Vehicle:</b> "+v+" | <b>Team:</b> "+tm+"</p>");
  lines.push("<p class='sub'><b>Drivers:</b> "+drs.join(", ")+"</p>");

  lines.push("<div class='kpis'>");
  lines.push("<div class='kpi'><div class='l'>Best Lap</div><div class='v'>"+ft(bl?bl.lapSec:null)+"</div></div>");
  lines.push("<div class='kpi'><div class='l'>Top 3 Avg</div><div class='v'>"+ft(t3)+"</div></div>");
  lines.push("<div class='kpi'><div class='l'>Theo. Best</div><div class='v'>"+ft(tb)+"</div></div>");
  const gapVal = bl&&cb ? bl.lapSec-cb.lapSec : null;
  const gapCls = gapVal!=null&&gapVal>0 ? "neg" : "pos";
  lines.push("<div class='kpi'><div class='l'>Gap to Class</div><div class='v "+gapCls+"'>"+fgs(gapVal)+"</div></div>");
  lines.push("</div>");

  lines.push("<h2>Sector Analysis</h2>");
  lines.push("<table><tr><th>Sector</th><th>Track Section</th><th>Car</th><th>Class Best</th><th>Gap</th></tr>");
  SL.forEach((l,i) => {
    const g = abs2[i]&&cbs[i] ? abs2[i]-cbs[i] : null;
    const gc = g!=null&&g>0 ? "neg" : "pos";
    lines.push("<tr><td><b>"+l+"</b></td><td>"+SNAMES[l]+"</td><td class='mono'>"+ft(abs2[i])+"</td><td class='mono'>"+ft(cbs[i])+"</td><td class='mono "+gc+"'>"+fgs(g)+"</td></tr>");
  });
  lines.push("</table>");

  // Driver breakdown
  lines.push("<h2>Driver Breakdown</h2>");
  lines.push("<table><tr><th>Driver</th><th>Flying Laps</th><th>Best Lap</th><th>Top 3 Avg</th></tr>");
  drs.forEach(dr => {
    const dl = carF.filter(d=>d.activeDriver===dr);
    const dbl = dl.length ? minBy(dl,"lapSec").lapSec : null;
    const dt3 = dl.length>=3 ? meanBy(sortBy(dl,"lapSec").slice(0,3),"lapSec") : (dl.length?meanBy(dl,"lapSec"):null);
    lines.push("<tr><td><b>"+dr+"</b></td><td>"+dl.length+"</td><td class='mono'>"+ft(dbl)+"</td><td class='mono'>"+ft(dt3)+"</td></tr>");
  });
  lines.push("</table>");

  lines.push("<div style='margin-top:40px;padding-top:15px;border-top:2px solid #DC2626;font-size:11px;color:#94a3b8;text-align:center'>NLS Race Analytics | Generated "+new Date().toLocaleDateString()+"</div>");
  lines.push("</body></html>");

  const html = lines.join("\n");
  const blob = new Blob([html], {type:"text/html;charset=utf-8"});
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Report_"+car+"_"+cls.replace(/\s/g,"_")+".html";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/* ================================================================
   MAIN APP
   ================================================================ */
export default function App() {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== "undefined") {
      try { return localStorage.getItem("vds-theme") || "dark"; } catch(e) {}
    }
    return "dark";
  });
  T = THEMES[theme] || THEMES.dark;
  useEffect(() => {
    try { localStorage.setItem("vds-theme", theme); } catch(e) {}
  }, [theme]);
  const toggleTheme = () => setTheme(t => t === "dark" ? "light" : "dark");

  const [races, setRaces] = useState([]);
  const [activeRace, setActiveRace] = useState(0);
  const [tab, setTab] = useState("dashboard");
  const [car, setCar] = useState(null);
  const [cls, setCls] = useState(null);
  const [hl, setHl] = useState(null);
  const [showManager, setShowManager] = useState(true);

  const data = races[activeRace] ? races[activeRace].data : [];
  const classes = useMemo(() => data.length ? uniq(data.map(d=>d.klasse)).sort() : [], [data]);
  const carsInClass = useMemo(() => {
    if (!data.length || !cls) return [];
    return Object.entries(groupBy(data.filter(d=>d.klasse===cls),"stnr")).map(([s,laps]) => ({stnr:+s,label:"#"+s+" - "+(laps[0]?laps[0].vehicle:"?")})).sort((a,b) => a.stnr-b.stnr);
  }, [data,cls]);

  // When races change, set defaults
  useEffect(() => {
    if (!races.length) { setShowManager(true); return; }
    const d = races[activeRace]?.data || [];
    if (!d.length) return;
    const cl = uniq(d.map(x=>x.klasse)).sort();
    const dc = cl.find(c=>c.includes("M240i")) || cl[0];
    setCls(dc);
    const clsLaps = d.filter(x=>x.klasse===dc);
    const f665 = clsLaps.find(x=>x.stnr===665);
    setCar(f665 ? 665 : clsLaps[0]?.stnr || d[0]?.stnr || null);
    if (f665) setHl(665);
  }, [races, activeRace]);

  useEffect(() => {
    if (carsInClass.length && !carsInClass.find(c=>c.stnr===car)) {
      const pref = carsInClass.find(c=>c.stnr===hl);
      setCar(pref ? pref.stnr : carsInClass[0].stnr);
    }
  }, [carsInClass,car,hl]);

  const tabs = [
    {k:"dashboard",l:"Dashboard"},{k:"battle",l:"Head-to-Head"},{k:"sectors",l:"Sectors"},{k:"drivers",l:"Drivers"},
    {k:"class",l:"Class"},{k:"radar",l:"Radar"},{k:"coaching",l:"Coaching"},
    {k:"compare",l:"Compare"},{k:"detail",l:"Detail"},{k:"guide",l:"Guide"}
  ];

  const raceInfo = useMemo(() => {
    if (!data.length) return null;
    return { cars: uniq(data.map(d=>d.stnr)).length, laps: data.length, classes: classes.length };
  }, [data,classes]);

  // Race Manager view
  if (showManager) {
    return (
      <div style={{minHeight:"100vh",background:T.bg,color:T.tx,fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>
        <div style={{background:T.sf,borderBottom:"1px solid "+T.bd,position:"relative"}}>
          <div style={{position:"absolute",left:0,right:0,bottom:0,height:2,background:T.ac}} />
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 22px",gap:20,minHeight:68}}>
            <div style={{display:"flex",alignItems:"center",gap:18}}>
              <VDSLogo height={44} />
              <div style={{width:1,height:32,background:T.bdl}} />
              <div style={{display:"flex",flexDirection:"column",gap:3}}>
                <div style={{fontSize:18,fontWeight:700,color:T.tx,letterSpacing:"-0.02em",lineHeight:1}}>NLS Race Analytics</div>
                <div style={{fontSize:10,fontWeight:600,color:T.txm,textTransform:"uppercase",letterSpacing:"0.08em"}}>Race Manager</div>
              </div>
            </div>
            <button onClick={toggleTheme} title={"Switch theme"}
              style={{width:36,height:36,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:16,background:"transparent",border:"1px solid "+T.bdl,color:T.txm,borderRadius:2}}>
              {theme==="dark"?"☾":"☀"}
            </button>
          </div>
        </div>
        <div style={{padding:"24px 16px",display:"flex",justifyContent:"center"}}>
          <RaceManager races={races} setRaces={setRaces} activeRace={activeRace} setActiveRace={setActiveRace}
            onDone={() => setShowManager(false)} />
        </div>
      </div>
    );
  }

  return (
    <div style={{minHeight:"100vh",background:T.bg,color:T.tx,fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>
      {/* HEADER — VDS branding row */}
      <div style={{background:T.sf,borderBottom:"1px solid "+T.bd,position:"sticky",top:0,zIndex:100}}>
        <div style={{position:"absolute",left:0,right:0,bottom:0,height:2,background:T.ac}} />
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 22px",gap:20,minHeight:68}}>
          <div style={{display:"flex",alignItems:"center",gap:18}}>
            <VDSLogo height={44} />
            <div style={{width:1,height:32,background:T.bdl}} />
            <div style={{display:"flex",flexDirection:"column",gap:3}}>
              <div style={{fontSize:18,fontWeight:700,color:T.tx,letterSpacing:"-0.02em",lineHeight:1}}>NLS Race Analytics</div>
              {races[activeRace] && (
                <div style={{fontSize:10,fontWeight:600,color:T.txm,textTransform:"uppercase",letterSpacing:"0.08em",display:"flex",alignItems:"center",gap:8}}>
                  <span>{races[activeRace].name}</span>
                  <span style={{width:3,height:3,borderRadius:"50%",background:T.txd}} />
                  <span>{races[activeRace].weather==="dry"?"Dry":races[activeRace].weather==="wet"?"Wet":"Mixed"}{races[activeRace].temp?" · "+races[activeRace].temp:""}</span>
                  {cls && <><span style={{width:3,height:3,borderRadius:"50%",background:T.txd}} /><span>{cls}</span></>}
                </div>
              )}
            </div>
          </div>
          <button onClick={toggleTheme} title={"Switch to "+(theme==="dark"?"light":"dark")+" mode"}
            style={{width:36,height:36,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:16,background:"transparent",border:"1px solid "+T.bdl,color:T.txm,borderRadius:2}}>
            {theme==="dark"?"☾":"☀"}
          </button>
        </div>
        {/* FILTER BAR */}
        {data.length > 0 && (
          <div style={{display:"flex",alignItems:"center",gap:14,padding:"10px 22px",borderTop:"1px solid "+T.bd,flexWrap:"wrap"}}>
            {races.length > 1 && <Sel label="Race" value={activeRace} onChange={v=>setActiveRace(+v)} options={races.map((r,i)=>({value:i,label:r.name}))} w={120} />}
            <Sel label="Class" value={cls||""} onChange={setCls} options={classes.map(c=>({value:c,label:c}))} w={100} />
            <Sel label="Car" value={car||""} onChange={v=>setCar(+v)} options={carsInClass.map(c=>({value:c.stnr,label:c.label}))} w={170} />
            <div style={{display:"flex",flexDirection:"column",gap:3}} title="Highlight: visually marks this car number in charts and tables. Does not filter data.">
              <label style={{fontSize:9,color:T.txm,textTransform:"uppercase",fontWeight:700,letterSpacing:"0.08em",cursor:"help"}}>Highlight</label>
              <input type="number" value={hl||""} onChange={e=>setHl(+e.target.value||null)} placeholder="#"
                style={{width:54,background:T.bg,color:T.ac,border:"1px solid "+T.bdl,borderRadius:2,padding:"5px 6px",fontSize:11,fontFamily:"'SF Mono',Monaco,monospace",fontWeight:700,textAlign:"center",outline:"none"}} />
            </div>
            <div style={{flex:1}} />
            <button onClick={() => doExport(data,car,cls)}
              style={{background:"transparent",color:T.tx,border:"1px solid "+T.bdl,borderRadius:2,padding:"5px 14px",fontSize:10,cursor:"pointer",fontWeight:700,textTransform:"uppercase",letterSpacing:"0.08em"}}>Export</button>
            <button onClick={() => setShowManager(true)}
              style={{background:T.ac,color:"#FAFAFA",border:"1px solid "+T.ac,borderRadius:2,padding:"5px 14px",fontWeight:700,fontSize:10,cursor:"pointer",textTransform:"uppercase",letterSpacing:"0.08em"}}>
              Race Manager
            </button>
          </div>
        )}
      </div>

      {/* CONTENT */}
      {data.length > 0 && (
        <div style={{padding:"0 16px 24px"}}>
          {/* Race chips */}
          {races.length > 1 && (
            <div style={{display:"flex",gap:6,padding:"10px 0 4px",flexWrap:"wrap"}}>
              {races.map((r,i) => {
                const wi = r.weather==="dry"?"☀️":r.weather==="wet"?"🌧️":"⛅";
                return (<div key={i} onClick={()=>setActiveRace(i)} style={{display:"flex",alignItems:"center",gap:4,padding:"3px 10px",fontSize:10,borderRadius:5,border:"1px solid "+(i===activeRace?T.ac:T.bd),background:i===activeRace?T.acg:"transparent",color:i===activeRace?T.ac:T.txm,cursor:"pointer"}}>
                  {wi} {r.name} {r.temp&&<span style={{color:T.txd}}>({r.temp})</span>}
                </div>);
              })}
            </div>
          )}
          <div style={{display:"flex",gap:0,padding:"0 0 0 0",overflowX:"auto",borderBottom:"1px solid "+T.bd,marginBottom:16,marginTop:10}}>
            {tabs.map(t => <TabBtn key={t.k} active={tab===t.k} label={t.l} onClick={()=>setTab(t.k)} />)}
          </div>
          {tab==="dashboard" && <DashboardTab data={data} car={car} hl={hl} races={races} activeRace={activeRace} />}
          {tab==="battle" && <BattleTab data={data} car={car} cls={cls} />}
          {tab==="sectors" && <SectorTab data={data} car={car} cls={cls} />}
          {tab==="drivers" && <DriverTab data={data} car={car} />}
          {tab==="class" && <ClassTab data={data} cls={cls} car={car} />}
          {tab==="radar" && <RadarTab data={data} cls={cls} car={car} />}
          {tab==="coaching" && <CoachingTab data={data} car={car} cls={cls} />}
          {tab==="compare" && <CompareTab races={races} activeRace={activeRace} />}
          {tab==="detail" && <DetailTab data={data} car={car} />}
          {tab==="guide" && <GuideTab />}
        </div>
      )}

      {!data.length && (
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:"60vh"}}>
          <div style={{textAlign:"center"}}>
            <div style={{fontSize:14,color:T.txm,marginBottom:10}}>No race data loaded</div>
            <button onClick={()=>setShowManager(true)} style={{background:T.ac,color:T.bg,border:"none",borderRadius:6,padding:"8px 20px",fontWeight:700,fontSize:12,cursor:"pointer"}}>Open Race Manager</button>
          </div>
        </div>
      )}

      <div style={{padding:"14px 22px",borderTop:"1px solid "+T.bd,display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:6}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <VDSLogo height={20} />
          <div style={{fontSize:9,fontWeight:700,color:T.txm,textTransform:"uppercase",letterSpacing:"0.08em"}}>NLS Race Analytics v4 · {new Date().getFullYear()}</div>
        </div>
        <div style={{fontSize:9,color:T.txd,textTransform:"uppercase",letterSpacing:"0.08em"}}>Nurburgring Langstrecken Serie</div>
      </div>
    </div>
  );
}
